import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	Row,
	Col,
	Button,
	Form,
	Tabs,
	Tab,
	Toast,
	Modal,
	OverlayTrigger,
	Tooltip,
} from "react-bootstrap";
import {
	IoMdCreate,
	IoIosAdd,
	IoMdSquare,
	IoIosClose,
	IoMdDoneAll,
	IoMdClock,
	IoIosEye,
	IoMdTrash,
	IoMdRefresh,
	IoIosPlay,
	IoMdCalendar,
	IoMdSettings,
	IoIosInformationCircle,
	IoIosBulb,
	IoMdDownload,
} from "react-icons/io";
import { FaBan } from "react-icons/fa";
import DatePicker from "react-datepicker";
import Select from "react-dropdown-select";
import moment from "moment";

// Local imports
import Loader from "../../../components/Loader";
import ReactTable from "../../../components/FilterTable";

import {
	fetchTasks,
	fetchTaskDropdownLists,
	addTask,
} from "../../../actions/task/taskActions";
import {
	fetchEditTask,
	cancelEditingTask,
	updateTask,
	setEditInitialState,
	updateContinueTask,
} from "../../../actions/task/editTaskActions";
import CommunicationConfiguration from "./CommunicationConfiguration";
import DataSecurity from "./DataSecurity";
import { _HttpServices } from "../../../_services/_HttpServices";
import getExcel from "../../../_services/ExcelUtility";
import { logoutSuccess } from "../../../actions/user/userActions";
import { env } from "../../../_services/env";
import { Footer } from "../../../components/Footer";

const TaskPage = ({
	dispatch,
	loading,
	hasErrors,
	tasks,
	taskDropdownLists,
	editLoading,
	editTask,
	editHasErrors,
	match,
	editingTask,
	editingLoading,
	editingSuccessToaster,
	editingErrorToaster,
	errorTaskCreationToaster,
}) => {
	const fileName = "Tasks";
	// States
	const [loader, setLoader] = useState(false);
	const [show, setShow] = useState(false);
	const [adding, setAdding] = useState(false);
	const [validated, setValidated] = useState(false);
	const [editing, setEditing] = useState(false);
	const [submitBtnDisable, setSubmitBtnDisable] = useState(true);
	const [continueBtnDisable, setContinueBtnDisable] = useState(true);
	const [editDisable, setEditDisable] = useState(false);
	const [viewTask, setViewTask] = useState(false);
	const [viewTaskId, setViewTaskId] = useState(0);
	const [submitSaveOrUpdate, setSubmitSaveOrUpdate] = useState(null);
	const [submitSaveOrUpdateContinue, setSubmitSaveOrUpdateContinue] =
		useState(false);
	const [inbound, setInbound] = useState(false);
	const [outbound, setOutbound] = useState(false);
	const [Notify, setNotify] = useState(false);
	const [scheduleTypeDaily, setScheduleTypeDaily] = useState(true);
	const [scheduleTypeWeekly, setScheduleTypeWeekly] = useState(false);
	const [scheduleTypeMonthly, setScheduleTypeMonthly] = useState(false);
	const [scheduleTypeQuarterly, setScheduleTypeQuarterly] = useState(false);
	const [occursOnceAtInputDisable, setOccursOnceAtInputDisable] =
		useState(false);
	const [occursEveryInputDisable, setOccursEveryInputDisable] = useState(false);
	const [dayXMonthsDisable, setDayXMonthsDisable] = useState(false);
	const [theXMonthsDisable, setTheXMonthsDisable] = useState(false);

	const [monthXQuarterlyDisable, setMonthXQuarterlyDisable] = useState(false);
	const [theXQuarterlyDisable, setTheXQuarterlyDisable] = useState(false);
	const [showCOnfirm, setShowConfirm] = useState(false);
	const [taskValuesChanged, setTaskValuesChanged] = useState(false);
	const [currentTab, setCurrentTab] = useState("");
	// Error states
	const [emailErr, setEmailErr] = useState([]);
	const [errEmail, setErrEmail] = useState(false);
	const [taskNameError, setTaskNameError] = useState(false);
	const [startTimeGreaterErr, setStartTimeGreaterErr] = useState(false);
	const [startDateGreaterErr, setStartDateGreaterErr] = useState(false);
	const [startDateErr, setStartDateErr] = useState(false);

	// Date Time states
	const [occursOnceAt, setOccursOnceAt] = useState(new Date());
	const [occursEveryStartTime, setOccursEveryStartTime] = useState(new Date());
	const [occursEveryEndTime, setOccursEveryEndTime] = useState(new Date());
	const [startDate, setStartDate] = useState(new Date());
	const [endDate, setEndDate] = useState(new Date());

	// Toaster
	const [showToaster, setShowToaster] = useState(false);
	const [deleteToaster, setDeleteToaster] = useState(false);
	const [enableTaskTaskoaster, setenableTaskTaskoaster] = useState(false);
	const [stopToaster, setStopToaster] = useState(false);
	const [restartToaster, setRestartToaster] = useState(false);
	const [startToaster, setStartToaster] = useState(false);
	const [DeleteTask, setDeleteTask] = useState(null);

	// Edit task
	const [ScheduleWeekdays, setScheduleWeekdays] = useState([]);
	const [isEndDateDisable, setIsEndDateDisable] = useState(false);
	const [IsExcludeHolidays, setIsExcludeHolidays] = useState(true);
	// Select File Source
	const initialState = {
		// Select Client
		Id: 0,
		ClientId: "The CIBD Distributors",
		FileSourceTypeId: "Select File Source",
		FileTypeId: "Select File",
		FileFormatId: "Select File Format",
		EDITaskTypeId: "Select Task Type",
		TaskName: "",
		FileNameFormat: "",
		OutboundResponsePath: "",
		ReadTries: "1",
		File_Receive_Path: "",
		SuccessArchivePath: "",
		FailureArchivePath: "",
		Notify: "Y",
		NotifyEmail: "",
		ScheduleTypeId: "Daily",
		EveryXDays: "",
		EveryXWeeks: "",
		ScheduleWeekday: ScheduleWeekdays,
		DaysOfMonth: "Y",
		DayOfMonth: "",
		EveryXMonths: "",
		EveryXMonths2: "",
		MonthlySpecificDatePartOne: "First",
		MonthlySpecificDatePartTwo: "Day",
		IsOccursOnceAt: "Y",
		EveryXminutes: "",
		TimeRecurrenceTypeId: "Hours",
		SpecificTime: occursOnceAt,
		StartTime: occursEveryStartTime,
		EndTime: occursEveryEndTime,
		IsEndDate: "Y",
		StartDate: startDate,
		EndDate: endDate,
		NoEndDate: "",
		IsExcludeHolidays: true,
		MonthsOfQuarterly: "Y",
		MonthOfQuarterly: "FirstMonth",
		DayOfQuarterlyMonth: "",
		EveryXQuarterlyMonths: "",
		MonthOfQuarterly2: "FirstMonth",
		QuarterlySpecificDatePartOne: "First",
		QuarterlySpecificDatePartTwo: "Day",
		EveryXQuarterlyMonths2: "",
	};
	const [task, setTask] = useState(initialState);
	const [prevTask, setPrevTask] = useState(initialState);
	const [userName, setUserName] = useState("");
	const [roleId, setRoleId] = useState(0);
	const [isLogin, setIsLogin] = useState(localStorage.getItem("loggedIn"));

	const history = useHistory();
	const taskData = tasks;

	// Communication configuration
	const intialTabKey = "TaskConfiguration";
	const [tabActiveKey, setTabActiveKey] = useState(intialTabKey);
	let config = false;
	const deleteTask = (task) => {
		setDeleteTask(task);
		setShowConfirm(true);
	};

	useEffect(() => {
		if (isLogin === null) {
			dispatch(logoutSuccess());
			localStorage.clear();
			history.push("/");
		}
	}, [isLogin]);

	useEffect(() => {
		const id = match.params.id;
		if (id) {
			setIsLogin(localStorage.getItem("loggedIn"));
			dispatch(fetchTaskDropdownLists());
			if (isLogin !== null) {
				dispatch(fetchEditTask(id));
			}
		} else {
			dispatch(fetchTasks());
			setLoader(false);
		}
		setViewTaskId(id);

		if (localStorage.getItem("userData")) {
			const userData = localStorage.getItem("userData");
			setUserName(JSON.parse(userData).FirstName);
			setRoleId(JSON.parse(userData).RoleID);
		}

		if (editingSuccessToaster) {
			setShowToaster(true);
		}
		if (editingErrorToaster) {
			setShowToaster(true);
		}
	}, [dispatch]);

	useEffect(() => {
		taskUpdate(task);
	}, [task]);

	// For edit task ====================================================================================================== edit task ===
	useEffect(() => {
		if (viewTaskId && roleId !== 1) {
			setLoader(true);
			setViewTask(true);
		}

		if (editingTask) {
			let taskParam = window.location.hash.split("/");
			taskParam.map((x) => {
				if (x === "view") {
					setIsLogin(localStorage.getItem("loggedIn"));
					setShow(true);
					setEditing(false);
					setEditDisable(false);
					mappingToTaskPrevTask(editTask);
					return setViewTask(true);
				} else if (x === "edit") {
					setIsLogin(localStorage.getItem("loggedIn"));
					setShow(true);
					setEditing(true);
					setEditDisable(true);
					mappingToTaskPrevTask(editTask);
					return setViewTask(false);
				} else {
					setShow(false);
					setEditing(false);
					setEditDisable(false);
					return setViewTask(false);
				}
			});
		} else {
			setEditing(false);
			setShow(false);
			setTask(initialState);
		}
		setLoader(false);
	}, [editingTask, match, editTask]);

	const mappingToTaskPrevTask = (editTask) => {
		let EditTaskClientId = "";
		if (taskDropdownLists.length > 0) {
			taskDropdownLists[0].Client.map((client) => {
				if (client.Id === editTask.ClientId) {
					EditTaskClientId = client.ClientName;
				}
			});
		}

		let EditTaskFileSourceTypeId = "";
		if (taskDropdownLists.length > 0) {
			taskDropdownLists[0].FileSourceTypeList.map((source) => {
				if (source.Id === editTask.FileSourceTypeId) {
					EditTaskFileSourceTypeId = source.FileSourceName;
				}
			});
		}

		let EditTaskFileTypeId = "";
		if (taskDropdownLists.length > 0) {
			taskDropdownLists[0].FileTypesList.map((file) => {
				if (file.Id === editTask.FileTypeId) {
					EditTaskFileTypeId = file.FileTypeName;
				}
			});
		}

		let EditTaskFileFormatId = "";
		if (taskDropdownLists.length > 0) {
			taskDropdownLists[0].FileFormatList.map((file) => {
				if (file.Id === editTask.FileFormatId) {
					EditTaskFileFormatId = file.FileFormatName;
				}
			});
		}

		let EditTaskEDITaskTypeId = "";
		if (taskDropdownLists.length > 0) {
			taskDropdownLists[0].EdiTaskTypesList.map((type) => {
				if (type.TaskTypeId === editTask.EDITaskTypeId) {
					EditTaskEDITaskTypeId = type.TaskTypeDescription;
				}
			});
		}

		let EditTaskScheduleTypeId = "";
		if (taskDropdownLists.length > 0) {
			taskDropdownLists[0].SchdulerType.map((schedule) => {
				if (schedule.Id === editTask.ScheduleTypeId) {
					EditTaskScheduleTypeId = schedule.ScheduleType;
				}
			});
		}

		let EditTaskMonthlySpecificDatePartOneId = "";
		if (taskDropdownLists.length > 0) {
			taskDropdownLists[0].MonthlySpecificDatePartOneList.map((list) => {
				if (list.data === editTask.MonthlySpecificDatePartOne) {
					EditTaskMonthlySpecificDatePartOneId = list.value;
				}
			});
		}

		let EditTaskMonthlySpecificDatePartTwoId = "";
		if (taskDropdownLists.length > 0) {
			taskDropdownLists[0].MonthlySpecificDatePartTwoList.map((list) => {
				if (list.data === editTask.MonthlySpecificDatePartTwo) {
					EditTaskMonthlySpecificDatePartTwoId = list.value;
				}
			});
		}

		// Quarterly
		let EditTaskMonthOfQuarterly = "";
		if (taskDropdownLists.length > 0) {
			taskDropdownLists[0].QuarterlyMonths.map((item) => {
				if (item.data === editTask.MonthOfQuarterly) {
					EditTaskMonthOfQuarterly = item.value;
				}
			});
		}

		let EditTaskMonthOfQuarterly2 = "";
		if (taskDropdownLists.length > 0) {
			taskDropdownLists[0].QuarterlyMonths.map((item) => {
				if (item.data === editTask.MonthOfQuarterly2) {
					EditTaskMonthOfQuarterly2 = item.value;
				}
			});
		}

		let EditTaskQuarterlySpecificDatePartOne = "";
		if (taskDropdownLists.length > 0) {
			taskDropdownLists[0].MonthlySpecificDatePartOneList.map((list) => {
				if (list.data === editTask.QuarterlySpecificDatePartOne) {
					EditTaskQuarterlySpecificDatePartOne = list.value;
				}
			});
		}

		let EditTaskQuarterlySpecificDatePartTwo = "";
		if (taskDropdownLists.length > 0) {
			taskDropdownLists[0].MonthlySpecificDatePartTwoList.map((list) => {
				if (list.data === editTask.QuarterlySpecificDatePartTwo) {
					EditTaskQuarterlySpecificDatePartTwo = list.value;
				}
			});
		}

		let EditTaskTimeRecurrenceTypeId = "";
		if (taskDropdownLists.length > 0) {
			taskDropdownLists[0].TimeRecurrenceType.map((time) => {
				if (time.data === editTask.TimeRecurrenceTypeId) {
					EditTaskTimeRecurrenceTypeId = time.value;
				}
			});
		}

		let EditTaskNotify = "";
		if (editTask.Notify === "Y") {
			EditTaskNotify = "Y";
			setNotify(true);
		} else {
			EditTaskNotify = "N";
			setNotify(false);
		}

		// let ScheduleDayes = [];
		// if (editTask.ScheduleDay !== null && editTask.ScheduleDay) {
		//     let weekDays = editTask.ScheduleDay.replace(/,(?=\s*$)/, '')
		//     let weekDaysArray = weekDays.split(",")

		//     const newValue = weekDaysArray.map((str, index) => {
		//         let obj = { label: str, value: 0 }
		//         if (str === "Sunday") {
		//             obj.value = 1
		//         } else if (str === "Monday") {
		//             obj.value = 2
		//         } else if (str === "Tuesday") {
		//             obj.value = 3
		//         } else if (str === "Wednesday") {
		//             obj.value = 4
		//         } else if (str === "Thursday") {
		//             obj.value = 5
		//         } else if (str === "Friday") {
		//             obj.value = 6
		//         } else if (str === "Saturday") {
		//             obj.value = 7
		//         }
		//         return obj
		//     })
		//     setScheduleDays(newValue)
		//     ScheduleDayes = newValue
		// }

		let EditTaskHolidays = "";
		if (editTask.IsExcludeHolidays) {
			EditTaskHolidays = true;
			setIsExcludeHolidays(true);
		} else {
			EditTaskHolidays = false;
			setIsExcludeHolidays(false);
		}

		let ScheduleWeekDayes = [];
		if (editTask.ScheduleWeekday !== null && editTask.ScheduleWeekday) {
			let weekDays = editTask.ScheduleWeekday.replace(/,(?=\s*$)/, "");
			let weekDaysArray = weekDays.split(",");

			const newValue = weekDaysArray.map((str, index) => {
				let obj = { label: str, value: 0 };
				if (str === "Sunday") {
					obj.value = 1;
				} else if (str === "Monday") {
					obj.value = 2;
				} else if (str === "Tuesday") {
					obj.value = 3;
				} else if (str === "Wednesday") {
					obj.value = 4;
				} else if (str === "Thursday") {
					obj.value = 5;
				} else if (str === "Friday") {
					obj.value = 6;
				} else if (str === "Saturday") {
					obj.value = 7;
				}
				return obj;
			});
			setScheduleWeekdays(newValue);
			ScheduleWeekDayes = newValue;
		}

		let EditTaskDaysOfMonth = "";
		if (editTask.EveryXMonths2 > 0) {
			EditTaskDaysOfMonth = "N";
		} else {
			EditTaskDaysOfMonth = "Y";
		}

		let EditTaskStartDate = new Date(editTask.StartDate);
		setStartDate(EditTaskStartDate);

		let EditTaskEndDate = new Date(editTask.EndDate);
		let EditTaskEndDateFormat = editTask.EndDate.split("/");
		let EditTaskIsEndDate = "";

		if (
			EditTaskEndDateFormat[2] === "3000" ||
			editTask.EndDate === "" ||
			editTask.EndDate === null
		) {
			EditTaskIsEndDate = "N";
			setEndDate(new Date());
		} else {
			EditTaskIsEndDate = "Y";
			setEndDate(EditTaskEndDate);
		}

		// Time format
		let EditTaskSpecificTime = "";
		if (editTask.SpecificTime) {
			EditTaskSpecificTime = new Date(
				"01/01/2020 " +
					moment(editTask.SpecificTime, ["h:mm A"]).format("HH:mm")
			);
		} else {
			EditTaskSpecificTime = new Date();
		}
		let EditTaskStartTime = "";
		if (editTask.StartTime) {
			EditTaskStartTime = new Date(
				"01/01/2020 " + moment(editTask.StartTime, ["h:mm A"]).format("HH:mm")
			);
		} else {
			EditTaskStartTime = new Date();
		}
		let EditTaskEndTime = "";
		if (editTask.EndTime) {
			EditTaskEndTime = new Date(
				"01/01/2020 " + moment(editTask.EndTime, ["h:mm A"]).format("HH:mm")
			);
		} else {
			EditTaskEndTime = new Date();
		}

		setOccursOnceAt(EditTaskSpecificTime);
		setOccursEveryStartTime(EditTaskStartTime);
		setOccursEveryEndTime(EditTaskEndTime);

		let EditTaskIsOccursOnceAt = "";
		let EditTaskEveryXminutes = "";
		if (
			editTask.EveryXminutes === "" ||
			editTask.EveryXminutes === 0 ||
			editTask.EveryXminutes === null
		) {
			EditTaskIsOccursOnceAt = "Y";
			EditTaskEveryXminutes = "";
			setOccursEveryInputDisable(true);
			setOccursOnceAtInputDisable(false);
			setOccursOnceAt(EditTaskSpecificTime);

			setOccursEveryStartTime(new Date());
			setOccursEveryEndTime(new Date());
		} else {
			EditTaskIsOccursOnceAt = "N";
			EditTaskEveryXminutes = editTask.EveryXminutes;
			setOccursEveryInputDisable(false);
			setOccursOnceAtInputDisable(true);
			setOccursOnceAt(new Date());
		}

		let EditTaskEveryXDays = "";
		if (editTask.EveryXDays === 0 || editTask.EveryXDays === null) {
			EditTaskEveryXDays = "";
		} else {
			EditTaskEveryXDays = editTask.EveryXDays;
		}

		let EditTaskEveryXWeeks = "";
		if (editTask.EveryXWeeks === 0 || editTask.EveryXWeeks === null) {
			EditTaskEveryXWeeks = "";
		} else {
			EditTaskEveryXWeeks = editTask.EveryXWeeks;
		}

		let EditTaskDayOfMonth = "";
		if (editTask.DayOfMonth === 0 || editTask.DayOfMonth === null) {
			EditTaskDayOfMonth = "";
		} else {
			EditTaskDayOfMonth = editTask.DayOfMonth;
		}

		let EditTaskEveryXMonths = "";
		if (editTask.EveryXMonths === 0 || editTask.EveryXMonths === null) {
			EditTaskEveryXMonths = "";
		} else {
			EditTaskEveryXMonths = editTask.EveryXMonths;
		}

		let EditTaskEveryXMonths2 = "";
		if (editTask.EveryXMonths2 === 0 || editTask.EveryXMonths2 === null) {
			EditTaskEveryXMonths2 = "";
		} else {
			EditTaskEveryXMonths2 = editTask.EveryXMonths2;
		}

		let EditTaskReadTries = "";
		if (editTask.ReadTries === 0 || editTask.ReadTries === null) {
			EditTaskReadTries = "";
		} else {
			EditTaskReadTries = editTask.ReadTries;
		}

		if (editTask.EveryXminutes === 0) {
			EditTaskEveryXminutes = "";
		}

		let EditTaskMonthsOfQuarterly = "";
		if (editTask.DayOfQuarterlyMonth > 0) {
			EditTaskMonthsOfQuarterly = "Y";
		} else {
			EditTaskMonthsOfQuarterly = "N";
		}

		let EditTaskDayOfQuarterlyMonth = 0;
		if (editTask.DayOfQuarterlyMonth === 0) {
			EditTaskDayOfQuarterlyMonth = "";
		} else {
			EditTaskDayOfQuarterlyMonth = editTask.DayOfQuarterlyMonth;
		}

		let EditTaskEveryXQuarterlyMonths = 0;
		if (editTask.EveryXQuarterlyMonths === 0) {
			EditTaskEveryXQuarterlyMonths = "";
		} else {
			EditTaskEveryXQuarterlyMonths = editTask.EveryXQuarterlyMonths;
		}

		let EditTaskEveryXQuarterlyMonths2 = 0;
		if (editTask.EveryXQuarterlyMonths2 === 0) {
			EditTaskEveryXQuarterlyMonths2 = "";
		} else {
			EditTaskEveryXQuarterlyMonths2 = editTask.EveryXQuarterlyMonths2;
		}

		// ====================================================================================================== edit set task ==========
		setTask({
			Id: editTask.Id,
			ClientId: EditTaskClientId,
			FileSourceTypeId: EditTaskFileSourceTypeId,
			FileTypeId: EditTaskFileTypeId,
			FileFormatId: EditTaskFileFormatId,
			EDITaskTypeId: EditTaskEDITaskTypeId,
			ScheduleTypeId: EditTaskScheduleTypeId,
			MonthlySpecificDatePartOne: EditTaskMonthlySpecificDatePartOneId,
			MonthlySpecificDatePartTwo: EditTaskMonthlySpecificDatePartTwoId,
			TimeRecurrenceTypeId: EditTaskTimeRecurrenceTypeId,
			ScheduleWeekday: ScheduleWeekDayes,
			Notify: EditTaskNotify,
			DaysOfMonth: EditTaskDaysOfMonth,
			IsOccursOnceAt: EditTaskIsOccursOnceAt,
			EveryXminutes: EditTaskEveryXminutes,
			IsEndDate: EditTaskIsEndDate,
			IsExcludeHolidays: EditTaskHolidays,
			TaskName: editTask.TaskName,
			FileNameFormat: editTask.FileNameFormat,
			OutboundResponsePath: editTask.FileOutputPath,
			NotifyEmail: editTask.NotifyEmail,
			EveryXDays: EditTaskEveryXDays,
			EveryXWeeks: EditTaskEveryXWeeks,
			DayOfMonth: EditTaskDayOfMonth,
			EveryXMonths: EditTaskEveryXMonths,
			EveryXMonths2: EditTaskEveryXMonths2,
			SpecificTime: editTask.SpecificTime,
			EveryXminutes: editTask.EveryXminutes,
			StartTime: occursEveryStartTime,
			EndTime: editTask.EndTime,
			StartDate: editTask.StartDate,
			EndDate: editTask.EndDate,
			ReadTries: EditTaskReadTries,
			MonthsOfQuarterly: EditTaskMonthsOfQuarterly,
			DayOfQuarterlyMonth: EditTaskDayOfQuarterlyMonth,
			EveryXQuarterlyMonths: EditTaskEveryXQuarterlyMonths,
			EveryXQuarterlyMonths2: EditTaskEveryXQuarterlyMonths2,
			MonthOfQuarterly: EditTaskMonthOfQuarterly,
			MonthOfQuarterly2: EditTaskMonthOfQuarterly2,
			QuarterlySpecificDatePartOne: EditTaskQuarterlySpecificDatePartOne,
			QuarterlySpecificDatePartTwo: EditTaskQuarterlySpecificDatePartTwo,
			File_Receive_Path: editTask.File_Receive_Path,
			SuccessArchivePath: editTask.SuccessArchivePath,
			FailureArchivePath: editTask.FailureArchivePath,
		});

		// ====================================================================================================== edit set prev task ==========
		setPrevTask({
			Id: editTask.Id,
			ClientId: EditTaskClientId,
			FileSourceTypeId: EditTaskFileSourceTypeId,
			FileTypeId: EditTaskFileTypeId,
			FileFormatId: EditTaskFileFormatId,
			EDITaskTypeId: EditTaskEDITaskTypeId,
			ScheduleTypeId: EditTaskScheduleTypeId,
			MonthlySpecificDatePartOne: EditTaskMonthlySpecificDatePartOneId,
			MonthlySpecificDatePartTwo: EditTaskMonthlySpecificDatePartTwoId,
			TimeRecurrenceTypeId: EditTaskTimeRecurrenceTypeId,
			ScheduleWeekday: ScheduleWeekDayes,
			Notify: EditTaskNotify,
			DaysOfMonth: EditTaskDaysOfMonth,
			IsOccursOnceAt: EditTaskIsOccursOnceAt,
			EveryXminutes: EditTaskEveryXminutes,
			IsEndDate: EditTaskIsEndDate,
			IsExcludeHolidays: EditTaskHolidays,
			TaskName: editTask.TaskName,
			FileNameFormat: editTask.FileNameFormat,
			OutboundResponsePath: editTask.OutboundResponsePath,
			NotifyEmail: editTask.NotifyEmail,
			EveryXDays: EditTaskEveryXDays,
			EveryXWeeks: EditTaskEveryXWeeks,
			DayOfMonth: EditTaskDayOfMonth,
			EveryXMonths: EditTaskEveryXMonths,
			EveryXMonths2: EditTaskEveryXMonths2,
			SpecificTime: editTask.SpecificTime,
			EveryXminutes: editTask.EveryXminutes,
			StartTime: occursEveryStartTime,
			EndTime: editTask.EndTime,
			StartDate: editTask.StartDate,
			EndDate: editTask.EndDate,
			ReadTries: EditTaskReadTries,
			MonthsOfQuarterly: EditTaskMonthsOfQuarterly,
			DayOfQuarterlyMonth: EditTaskDayOfQuarterlyMonth,
			EveryXQuarterlyMonths: EditTaskEveryXQuarterlyMonths,
			EveryXQuarterlyMonths2: EditTaskEveryXQuarterlyMonths2,
			MonthOfQuarterly: EditTaskMonthOfQuarterly,
			MonthOfQuarterly2: EditTaskMonthOfQuarterly2,
			QuarterlySpecificDatePartOne: EditTaskQuarterlySpecificDatePartOne,
			QuarterlySpecificDatePartTwo: EditTaskQuarterlySpecificDatePartTwo,
			File_Receive_Path: editTask.File_Receive_Path,
			SuccessArchivePath: editTask.SuccessArchivePath,
			FailureArchivePath: editTask.FailureArchivePath,
		});
	};
	// For add task ====================================================================================================== add task ===
	// Add Task fn
	const addTaskHandler = async () => {
		setLoader(true);
		await dispatch(fetchTaskDropdownLists());
		await dispatch(cancelEditingTask());
		setLoader(false);
		setShow(true);
		setAdding(true);
		setValidated(false);
		setViewTask(false);
		setEditDisable(false);
		setTask(initialState);
		setOccursOnceAt(new Date());
	};

	// Trim values
	const trimValue = (event) => {
		const { name, value } = event.target;
		setTask({ ...task, [name]: value.trim() });
	};

	// ======================================================================================================= Data Reset ============
	const handleFileSourceChange = (data) => {
		if (editingTask) {
			const inboundReset = { ...task, FileSourceTypeId: "Inbound" };
			const outboundReset = { ...task, FileSourceTypeId: "Outbound" };
			if (data.FileSourceTypeId === "Inbound") {
				setTask(inboundReset);
			}

			if (data.FileSourceTypeId === "Outbound") {
				setTask(outboundReset);
			}
		} else {
			const inboundReset = {
				...initialState,
				FileSourceTypeId: "Inbound",
				ReadTries: "1",
			};
			const outboundReset = {
				...initialState,
				FileSourceTypeId: "Outbound",
				ReadTries: "",
			};
			if (data.FileSourceTypeId === "Inbound") {
				setTask(inboundReset);
			}

			if (data.FileSourceTypeId === "Outbound") {
				setTask(outboundReset);
			}
		}
	};

	const handleNotifyChange = (data) => {
		if (editingTask) {
			if (data.Notify === "N") {
				setTask({ ...task, Notify: "N", NotifyEmail: task.NotifyEmail });
			} else {
				setTask({ ...task, Notify: "Y" });
			}
		} else {
			if (data.Notify === "N") {
				setTask({ ...task, Notify: "N", NotifyEmail: "" });
			} else {
				setTask({ ...task, Notify: "Y" });
			}
		}
	};
	const handleHolidayChange = (event) => {
		const { name, value, checked } = event.target;
		if (editingTask) {
			if (name === "IsExcludeHolidays") {
				setTask({ ...task, IsExcludeHolidays: checked });
			}
		} else {
			if (name === "IsExcludeHolidays") {
				setTask({ ...task, IsExcludeHolidays: checked });
			}
		}
	};

	const onChangeScheduleWeekday = (value) => {
		// onChange={(value) => task.ScheduleWeekday = value}
		setTask(
			{
				...task,
				ScheduleWeekday: value,
			},
			taskUpdate(task)
		);
	};
	// const onChangeScheduleDay = (value) => {
	//     setTask({
	//         ...task, ScheduleDay: value
	//     }, taskUpdate(task))

	// }
	const handleScheduleTypeChange = (data) => {
		if (editingTask) {
			if (data.ScheduleTypeId === "Daily") {
				setTask({
					...task,
					ScheduleTypeId: "Daily",
					EveryXDays: "",
					EveryXWeeks: "",
					ScheduleWeekday: ScheduleWeekdays,
					DaysOfMonth: task.DaysOfMonth,
					DayOfMonth: task.DayOfMonth,
					EveryXMonths: task.EveryXMonths,
					IsExcludeHolidays: true,
					MonthlySpecificDatePartOne: task.MonthlySpecificDatePartOne,
					MonthlySpecificDatePartTwo: task.MonthlySpecificDatePartTwo,
					EveryXMonths2: task.EveryXMonths2,
					MonthOfQuarterly: task.MonthOfQuarterly,
					DayOfQuarterlyMonth: task.DayOfQuarterlyMonth,
					EveryXQuarterlyMonths: task.EveryXQuarterlyMonths,
					MonthOfQuarterly2: task.MonthOfQuarterly2,
					QuarterlySpecificDatePartOne: task.QuarterlySpecificDatePartOne,
					QuarterlySpecificDatePartTwo: task.QuarterlySpecificDatePartTwo,
					EveryXQuarterlyMonths2: task.EveryXQuarterlyMonths2,
				});
			} else if (data.ScheduleTypeId === "Weekly") {
				setTask({
					...task,
					ScheduleTypeId: "Weekly",
					EveryXDays: "",
					EveryXWeeks: "",
					ScheduleWeekday: ScheduleWeekdays,
					DaysOfMonth: task.DaysOfMonth,
					DayOfMonth: task.DayOfMonth,
					EveryXMonths: task.EveryXMonths,
					IsExcludeHolidays: true,
					MonthlySpecificDatePartOne: task.MonthlySpecificDatePartOne,
					MonthlySpecificDatePartTwo: task.MonthlySpecificDatePartTwo,
					EveryXMonths2: task.EveryXMonths2,
					MonthOfQuarterly: task.MonthOfQuarterly,
					DayOfQuarterlyMonth: task.DayOfQuarterlyMonth,
					EveryXQuarterlyMonths: task.EveryXQuarterlyMonths,
					MonthOfQuarterly2: task.MonthOfQuarterly2,
					QuarterlySpecificDatePartOne: task.QuarterlySpecificDatePartOne,
					QuarterlySpecificDatePartTwo: task.QuarterlySpecificDatePartTwo,
					EveryXQuarterlyMonths2: task.EveryXQuarterlyMonths2,
				});
			} else if (data.ScheduleTypeId === "Monthly") {
				setTask({
					...task,
					ScheduleTypeId: "Monthly",
					EveryXDays: "",
					EveryXWeeks: "",
					ScheduleWeekday: ScheduleWeekdays,
					DaysOfMonth: task.DaysOfMonth,
					DayOfMonth: task.DayOfMonth,
					EveryXMonths: task.EveryXMonths,
					IsExcludeHolidays: true,
					MonthlySpecificDatePartOne: task.MonthlySpecificDatePartOne,
					MonthlySpecificDatePartTwo: task.MonthlySpecificDatePartTwo,
					EveryXMonths2: task.EveryXMonths2,
					MonthOfQuarterly: task.MonthOfQuarterly,
					DayOfQuarterlyMonth: task.DayOfQuarterlyMonth,
					EveryXQuarterlyMonths: task.EveryXQuarterlyMonths,
					MonthOfQuarterly2: task.MonthOfQuarterly2,
					QuarterlySpecificDatePartOne: task.QuarterlySpecificDatePartOne,
					QuarterlySpecificDatePartTwo: task.QuarterlySpecificDatePartTwo,
					EveryXQuarterlyMonths2: task.EveryXQuarterlyMonths2,
				});
			} else if (data.ScheduleTypeId === "Quarterly") {
				setTask({
					...task,
					ScheduleTypeId: "Quarterly",
					EveryXDays: task.EveryXDays,
					EveryXWeeks: task.EveryXWeeks,
					ScheduleWeekday: ScheduleWeekdays,
					DaysOfMonth: task.DaysOfMonth,
					DayOfMonth: task.DayOfMonth,
					EveryXMonths: task.EveryXMonths,
					IsExcludeHolidays: true,
					MonthlySpecificDatePartOne: task.MonthlySpecificDatePartOne,
					MonthlySpecificDatePartTwo: task.MonthlySpecificDatePartTwo,
					EveryXMonths2: task.EveryXMonths2,
					MonthOfQuarterly: task.MonthOfQuarterly,
					DayOfQuarterlyMonth: task.DayOfQuarterlyMonth,
					EveryXQuarterlyMonths: task.EveryXQuarterlyMonths,
					MonthOfQuarterly2: task.MonthOfQuarterly2,
					QuarterlySpecificDatePartOne: task.QuarterlySpecificDatePartOne,
					QuarterlySpecificDatePartTwo: task.QuarterlySpecificDatePartTwo,
					EveryXQuarterlyMonths2: task.EveryXQuarterlyMonths2,
				});
			}
		} else {
			if (data.ScheduleTypeId === "Daily") {
				setTask({
					...task,
					ScheduleTypeId: "Daily",
					EveryXDays: "",
					EveryXWeeks: "",
					ScheduleWeekday: "",
					DaysOfMonth: "Y",
					DayOfMonth: "",
					EveryXMonths: "",
					MonthlySpecificDatePartOne: "First",
					MonthlySpecificDatePartTwo: "Day",
					EveryXMonths2: "",
					MonthsOfQuarterly: "Y",
					MonthOfQuarterly: "First Month",
					DayOfQuarterlyMonth: "",
					EveryXQuarterlyMonths: "",
					IsExcludeHolidays: true,
					MonthOfQuarterly2: "",
					QuarterlySpecificDatePartOne: "First",
					QuarterlySpecificDatePartTwo: "Day",
					EveryXQuarterlyMonths2: "",
				});
			} else if (data.ScheduleTypeId === "Weekly") {
				setTask({
					...task,
					ScheduleTypeId: "Weekly",
					EveryXDays: "",
					EveryXWeeks: "",
					ScheduleWeekday: "",
					DaysOfMonth: "Y",
					DayOfMonth: "",
					EveryXMonths: "",
					MonthlySpecificDatePartOne: "First",
					MonthlySpecificDatePartTwo: "Day",
					EveryXMonths2: "",
					IsExcludeHolidays: true,
					MonthsOfQuarterly: "Y",
					MonthOfQuarterly: "First Month",
					DayOfQuarterlyMonth: "",
					EveryXQuarterlyMonths: "",
					MonthOfQuarterly2: "",
					QuarterlySpecificDatePartOne: "First",
					QuarterlySpecificDatePartTwo: "Day",
					EveryXQuarterlyMonths2: "",
				});
			} else if (data.ScheduleTypeId === "Monthly") {
				setTask({
					...task,
					ScheduleTypeId: "Monthly",
					EveryXDays: "",
					EveryXWeeks: "",
					ScheduleWeekday: "",
					DaysOfMonth: "Y",
					DayOfMonth: "",
					EveryXMonths: "",
					MonthlySpecificDatePartOne: "First",
					MonthlySpecificDatePartTwo: "Day",
					EveryXMonths2: "",
					IsExcludeHolidays: true,
					MonthsOfQuarterly: "Y",
					MonthOfQuarterly: "First Month",
					DayOfQuarterlyMonth: "",
					EveryXQuarterlyMonths: "",
					MonthOfQuarterly2: "",
					QuarterlySpecificDatePartOne: "First",
					QuarterlySpecificDatePartTwo: "Day",
					EveryXQuarterlyMonths2: "",
				});
			} else if (data.ScheduleTypeId === "Quarterly") {
				setTask({
					...task,
					ScheduleTypeId: "Quarterly",
					EveryXDays: "",
					EveryXWeeks: "",
					ScheduleWeekday: "",
					DaysOfMonth: "Y",
					DayOfMonth: "",
					EveryXMonths: "",
					MonthlySpecificDatePartOne: "First",
					MonthlySpecificDatePartTwo: "Day",
					EveryXMonths2: "",
					IsExcludeHolidays: true,
					MonthsOfQuarterly: "Y",
					MonthOfQuarterly: "First Month",
					DayOfQuarterlyMonth: "",
					EveryXQuarterlyMonths: "",
					MonthOfQuarterly2: "",
					QuarterlySpecificDatePartOne: "First",
					QuarterlySpecificDatePartTwo: "Day",
					EveryXQuarterlyMonths2: "",
				});
			}
		}
	};

	const handleDaysOfMonthChange = (data) => {
		if (editingTask) {
			if (data.DaysOfMonth === "N") {
				setTask({ ...task, DaysOfMonth: "N" });
				if (editTask.EveryXMonths2 > 0) {
					setTask({
						...task,
						DaysOfMonth: "N",
						DayOfMonth: "",
						EveryXMonths: "",
					});
				}
			} else if (data.DaysOfMonth === "N") {
				setTask({
					...task,
					DaysOfMonth: "N",
					DayOfMonth: task.DayOfMonth,
					EveryXMonths: task.EveryXMonths,
				});
			} else if (data.DaysOfMonth === "Y") {
				setTask({ ...task, DaysOfMonth: "Y" });
				if (editTask.DayOfMonth > 0) {
					setTask({ ...task, DaysOfMonth: "Y", EveryXMonths2: "" });
				}
			} else {
				setTask({
					...task,
					DaysOfMonth: "Y",
					MonthlySpecificDatePartOne: task.MonthlySpecificDatePartOne,
					MonthlySpecificDatePartTwo: task.MonthlySpecificDatePartTwo,
					EveryXMonths2: task.EveryXMonths2,
				});
			}
		} else {
			if (data.DaysOfMonth === "N") {
				setTask({
					...task,
					DaysOfMonth: "N",
					DayOfMonth: "",
					EveryXMonths: "",
				});
			} else {
				setTask({
					...task,
					DaysOfMonth: "Y",
					MonthlySpecificDatePartOne: "First",
					MonthlySpecificDatePartTwo: "Day",
					EveryXMonths2: "",
				});
			}
		}
	};

	const handleMonthsOfQuarterlyChange = (data) => {
		if (editingTask) {
			if (data.MonthsOfQuarterly === "Y") {
				setTask({ ...task, MonthsOfQuarterly: "Y" });
				if (editTask.DayOfQuarterlyMonth > 0) {
					setTask({
						...task,
						MonthsOfQuarterly: "Y",
						MonthOfQuarterly: task.MonthOfQuarterly,
						DayOfQuarterlyMonth: task.DayOfQuarterlyMonth,
						EveryXQuarterlyMonths: task.EveryXQuarterlyMonths,
					});
				} else {
					setTask({
						...task,
						MonthsOfQuarterly: "Y",
						MonthOfQuarterly: "FirstMonth",
						DayOfQuarterlyMonth: "",
						EveryXQuarterlyMonths: "",
						MonthOfQuarterly2: "FirstMonth",
						QuarterlySpecificDatePartOne: "First",
						QuarterlySpecificDatePartTwo: "Day",
						EveryXQuarterlyMonths2: "",
					});
					// setTask({ ...task, MonthsOfQuarterly: "N", })
				}
			} else if (data.MonthsOfQuarterly === "N") {
				setTask({ ...task, MonthsOfQuarterly: "N" });
				if (editTask.EveryXQuarterlyMonths2 > 0) {
					setTask({
						...task,
						MonthsOfQuarterly: "N",
						MonthOfQuarterly2: task.MonthOfQuarterly2,
						QuarterlySpecificDatePartOne: task.QuarterlySpecificDatePartOne,
						QuarterlySpecificDatePartTwo: task.QuarterlySpecificDatePartTwo,
						EveryXQuarterlyMonths2: task.EveryXQuarterlyMonths2,
					});
				} else {
					setTask({
						...task,
						MonthsOfQuarterly: "N",
						MonthOfQuarterly2: "FirstMonth",
						QuarterlySpecificDatePartOne: "First",
						QuarterlySpecificDatePartTwo: "Day",
						EveryXQuarterlyMonths2: "",
						MonthOfQuarterly: "FirstMonth",
						DayOfQuarterlyMonth: "",
						EveryXQuarterlyMonths: "",
					});
					// setTask({ ...task, MonthsOfQuarterly: "Y", })
				}
			}
		} else {
			if (data.MonthsOfQuarterly === "N") {
				setTask({
					...task,
					MonthsOfQuarterly: "N",
					MonthOfQuarterly: "",
					DayOfQuarterlyMonth: "",
					EveryXQuarterlyMonths: "",
				});
			} else {
				setTask({
					...task,
					MonthsOfQuarterly: "Y",
					MonthOfQuarterly2: "First Month",
					QuarterlySpecificDatePartOne: "First",
					QuarterlySpecificDatePartTwo: "Day",
					EveryXQuarterlyMonths2: "",
				});
			}
		}
	};

	const handleOccursOnceAtChange = (data) => {
		if (editingTask) {
			if (data.IsOccursOnceAt === "N") {
				setTask({
					...task,
					IsOccursOnceAt: "N",
					SpecificTime: task.SpecificTime,
					TimeRecurrenceTypeId: task.TimeRecurrenceTypeId,
				});
			} else {
				setTask({
					...task,
					IsOccursOnceAt: "Y",
					EveryXminutes: task.EveryXminutes,
					TimeRecurrenceTypeId: task.TimeRecurrenceTypeId,
					StartTime: task.StartTime,
					EndTime: task.EndTime,
				});
			}
		} else {
			if (data.IsOccursOnceAt === "N") {
				setOccursOnceAt(new Date());
				setTask({
					...task,
					IsOccursOnceAt: "N",
					SpecificTime: occursOnceAt,
					TimeRecurrenceTypeId: "Hours",
				});
			} else {
				setOccursEveryStartTime(new Date());
				setOccursEveryEndTime(new Date());
				setTask({
					...task,
					IsOccursOnceAt: "Y",
					EveryXminutes: "",
					TimeRecurrenceTypeId: "Hours",
				});
			}
		}
	};

	// ======================================================================================================= Input Change fn ============
	const handleInputChange = (event) => {
		const { name, value } = event.target;

		if (
			name === "ReadTries" ||
			name === "EveryXDays" ||
			name === "EveryXWeeks" ||
			name === "DayOfMonth" ||
			name === "EveryXminutes" ||
			name === "EveryXMonths" ||
			name === "EveryXMonths2"
		) {
			// const regex = /^[a-zA-Z \b]+$/  // for strings
			const regex = /^[0-9\b]+$/; // for numbers
			const regexzero = /^[^0]\d*$/g;
			if (value === "" || (regex.test(value) && regexzero.test(value))) {
				setTask((task) => ({
					...task,
					[name]: value,
				}));
			}
		} else if (
			name === "EveryXQuarterlyMonths" ||
			name === "EveryXQuarterlyMonths2"
		) {
			const regex = /^[1-4\b]+$/;
			if (value === "" || regex.test(value)) {
				setTask((task) => ({
					...task,
					[name]: value,
				}));
			}
		} else if (name === "IsEndDate") {
			if (value === "N") {
				setTask({ ...task, [name]: value });
				setEndDate(new Date("01/01/3000"));
			} else if (value === "Y") {
				setTask({ ...task, [name]: value });
			}
		} else {
			setTask({ ...task, [name]: value });
		}
		setTaskNameError(false);
		setStartTimeGreaterErr(false);
		setStartDateGreaterErr(false);
		setStartDateErr(false);
	};

	// ======================================================================================================= Task Update ============
	const taskUpdate = (task) => {
		if (task.FileSourceTypeId === "Inbound") {
			setInbound(true);
			setOutbound(false);

			if (!editingTask) {
				// Button enable
				if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "Y" &&
					task.NotifyEmail.length > 0 &&
					task.ScheduleTypeId === "Daily" &&
					task.EveryXDays.length > 0 &&
					task.IsOccursOnceAt === "Y" &&
					task.IsEndDate === "Y"
				) {
					// Email yes, Daily, IsOccursOnceAt yes, IsEndDate yes
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "Y" &&
					task.NotifyEmail.length > 0 &&
					task.ScheduleTypeId === "Daily" &&
					task.EveryXDays.length > 0 &&
					task.IsOccursOnceAt === "N" &&
					task.EveryXminutes.length > 0 &&
					task.IsEndDate === "Y"
				) {
					// Email yes, Daily, IsOccursOnceAt no, IsEndDate yes
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "Y" &&
					task.NotifyEmail.length > 0 &&
					task.ScheduleTypeId === "Weekly" &&
					task.EveryXWeeks.length > 0 &&
					task.ScheduleWeekday.length > 0 &&
					task.IsOccursOnceAt === "Y" &&
					task.IsEndDate === "Y"
				) {
					// Email yes, Weekly, IsOccursOnceAt yes, IsEndDate yes
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "Y" &&
					task.NotifyEmail.length > 0 &&
					task.ScheduleTypeId === "Weekly" &&
					task.EveryXWeeks.length > 0 &&
					task.ScheduleWeekday.length > 0 &&
					task.IsOccursOnceAt === "N" &&
					task.EveryXminutes.length > 0 &&
					task.IsEndDate === "Y"
				) {
					// Email yes, Weekly, IsOccursOnceAt no, IsEndDate yes
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "Y" &&
					task.NotifyEmail.length > 0 &&
					task.ScheduleTypeId === "Monthly" &&
					task.DaysOfMonth === "Y" &&
					task.DayOfMonth.length > 0 &&
					task.EveryXMonths.length > 0 &&
					task.IsOccursOnceAt === "Y" &&
					task.IsEndDate === "Y"
				) {
					// Email yes, Monthly, DaysOfMonth yes, IsOccursOnceAt yes, IsEndDate yes
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "Y" &&
					task.NotifyEmail.length > 0 &&
					task.ScheduleTypeId === "Monthly" &&
					task.DaysOfMonth === "Y" &&
					task.DayOfMonth.length > 0 &&
					task.EveryXMonths.length > 0 &&
					task.IsOccursOnceAt === "N" &&
					task.EveryXminutes.length > 0 &&
					task.IsEndDate === "Y"
				) {
					// Email yes, Monthly, DaysOfMonth yes, IsOccursOnceAt no, IsEndDate yes
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "Y" &&
					task.NotifyEmail.length > 0 &&
					task.ScheduleTypeId === "Monthly" &&
					task.DaysOfMonth === "N" &&
					task.EveryXMonths2.length > 0 &&
					task.IsOccursOnceAt === "Y" &&
					task.IsEndDate === "Y"
				) {
					// Email yes, Monthly, DaysOfMonth no, IsOccursOnceAt yes, IsEndDate yes
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "Y" &&
					task.NotifyEmail.length > 0 &&
					task.ScheduleTypeId === "Monthly" &&
					task.DaysOfMonth === "N" &&
					task.EveryXMonths2.length > 0 &&
					task.IsOccursOnceAt === "N" &&
					task.EveryXminutes.length > 0 &&
					task.IsEndDate === "Y"
				) {
					// Email yes, Monthly, DaysOfMonth no, IsOccursOnceAt no, IsEndDate yes
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "Y" &&
					task.NotifyEmail.length > 0 &&
					task.ScheduleTypeId === "Quarterly" &&
					task.MonthsOfQuarterly === "Y" &&
					task.DayOfQuarterlyMonth.length > 0 &&
					task.EveryXQuarterlyMonths.length > 0 &&
					task.IsOccursOnceAt === "Y" &&
					task.IsEndDate === "Y"
				) {
					// Email yes, Quarterly, MonthsOfQuarterly yes, IsOccursOnceAt yes, IsEndDate yes
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "Y" &&
					task.NotifyEmail.length > 0 &&
					task.ScheduleTypeId === "Quarterly" &&
					task.MonthsOfQuarterly === "Y" &&
					task.DayOfQuarterlyMonth.length > 0 &&
					task.EveryXQuarterlyMonths.length > 0 &&
					task.IsOccursOnceAt === "N" &&
					task.EveryXminutes.length > 0 &&
					task.IsEndDate === "Y"
				) {
					// Email yes, Quarterly, MonthsOfQuarterly yes, IsOccursOnceAt no, IsEndDate yes
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "Y" &&
					task.NotifyEmail.length > 0 &&
					task.ScheduleTypeId === "Quarterly" &&
					task.MonthsOfQuarterly === "N" &&
					task.EveryXQuarterlyMonths2.length > 0 &&
					task.IsOccursOnceAt === "Y" &&
					task.IsEndDate === "Y"
				) {
					// Email yes, Quarterly, MonthsOfQuarterly no, IsOccursOnceAt yes, IsEndDate yes
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "Y" &&
					task.NotifyEmail.length > 0 &&
					task.ScheduleTypeId === "Quarterly" &&
					task.MonthsOfQuarterly === "N" &&
					task.EveryXQuarterlyMonths2.length > 0 &&
					task.IsOccursOnceAt === "N" &&
					task.EveryXminutes.length > 0 &&
					task.IsEndDate === "Y"
				) {
					// Email yes, Quarterly, MonthsOfQuarterly no, IsOccursOnceAt no, IsEndDate yes
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "Y" &&
					task.NotifyEmail.length > 0 &&
					task.ScheduleTypeId === "Daily" &&
					task.EveryXDays.length > 0 &&
					task.IsOccursOnceAt === "Y" &&
					task.IsEndDate === "N"
				) {
					// Email yes, Daily, IsOccursOnceAt yes, IsEndDate no
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "Y" &&
					task.NotifyEmail.length > 0 &&
					task.ScheduleTypeId === "Daily" &&
					task.EveryXDays.length > 0 &&
					task.IsOccursOnceAt === "N" &&
					task.EveryXminutes.length > 0 &&
					task.IsEndDate === "N"
				) {
					// Email yes, Daily, IsOccursOnceAt no, IsEndDate no
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "Y" &&
					task.NotifyEmail.length > 0 &&
					task.ScheduleTypeId === "Weekly" &&
					task.EveryXWeeks.length > 0 &&
					task.ScheduleWeekday.length > 0 &&
					task.IsOccursOnceAt === "Y" &&
					task.IsEndDate === "N"
				) {
					// Email yes, Weekly, IsOccursOnceAt yes, IsEndDate no
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "Y" &&
					task.NotifyEmail.length > 0 &&
					task.ScheduleTypeId === "Weekly" &&
					task.EveryXWeeks.length > 0 &&
					task.ScheduleWeekday.length > 0 &&
					task.IsOccursOnceAt === "N" &&
					task.EveryXminutes.length > 0 &&
					task.IsEndDate === "N"
				) {
					// Email yes, Weekly, IsOccursOnceAt no, IsEndDate no
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "Y" &&
					task.NotifyEmail.length > 0 &&
					task.ScheduleTypeId === "Monthly" &&
					task.DaysOfMonth === "Y" &&
					task.DayOfMonth.length > 0 &&
					task.EveryXMonths.length > 0 &&
					task.IsOccursOnceAt === "Y" &&
					task.IsEndDate === "N"
				) {
					// Email yes, Monthly, DaysOfMonth yes, IsOccursOnceAt yes, IsEndDate no
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "Y" &&
					task.NotifyEmail.length > 0 &&
					task.ScheduleTypeId === "Monthly" &&
					task.DaysOfMonth === "Y" &&
					task.DayOfMonth.length > 0 &&
					task.EveryXMonths.length > 0 &&
					task.IsOccursOnceAt === "N" &&
					task.EveryXminutes.length > 0 &&
					task.IsEndDate === "N"
				) {
					// Email yes, Monthly, DaysOfMonth yes, IsOccursOnceAt no, IsEndDate no
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "Y" &&
					task.NotifyEmail.length > 0 &&
					task.ScheduleTypeId === "Monthly" &&
					task.DaysOfMonth === "N" &&
					task.EveryXMonths2.length > 0 &&
					task.IsOccursOnceAt === "Y" &&
					task.IsEndDate === "N"
				) {
					// Email yes, Monthly, DaysOfMonth no, IsOccursOnceAt yes, IsEndDate no
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "Y" &&
					task.NotifyEmail.length > 0 &&
					task.ScheduleTypeId === "Monthly" &&
					task.DaysOfMonth === "N" &&
					task.EveryXMonths2.length > 0 &&
					task.IsOccursOnceAt === "N" &&
					task.EveryXminutes.length > 0 &&
					task.IsEndDate === "N"
				) {
					// Email yes, Monthly, DaysOfMonth no, IsOccursOnceAt yes, IsEndDate no
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "Y" &&
					task.NotifyEmail.length > 0 &&
					task.ScheduleTypeId === "Quarterly" &&
					task.MonthsOfQuarterly === "Y" &&
					task.DayOfQuarterlyMonth.length > 0 &&
					task.EveryXQuarterlyMonths.length > 0 &&
					task.IsOccursOnceAt === "Y" &&
					task.IsEndDate === "N"
				) {
					// Email yes, Monthly, MonthsOfQuarterly yes, IsOccursOnceAt yes, IsEndDate no
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "Y" &&
					task.NotifyEmail.length > 0 &&
					task.ScheduleTypeId === "Quarterly" &&
					task.MonthsOfQuarterly === "Y" &&
					task.DayOfQuarterlyMonth.length > 0 &&
					task.EveryXQuarterlyMonths.length > 0 &&
					task.IsOccursOnceAt === "N" &&
					task.EveryXminutes.length > 0 &&
					task.IsEndDate === "N"
				) {
					// Email yes, Monthly, MonthsOfQuarterly yes, IsOccursOnceAt no, IsEndDate no
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "Y" &&
					task.NotifyEmail.length > 0 &&
					task.ScheduleTypeId === "Quarterly" &&
					task.MonthsOfQuarterly === "N" &&
					task.EveryXQuarterlyMonths2.length > 0 &&
					task.IsOccursOnceAt === "Y" &&
					task.IsEndDate === "N"
				) {
					// Email yes, Monthly, MonthsOfQuarterly no, IsOccursOnceAt yes, IsEndDate no
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "Y" &&
					task.NotifyEmail.length > 0 &&
					task.ScheduleTypeId === "Quarterly" &&
					task.MonthsOfQuarterly === "N" &&
					task.EveryXQuarterlyMonths2.length > 0 &&
					task.IsOccursOnceAt === "N" &&
					task.EveryXminutes.length > 0 &&
					task.IsEndDate === "N"
				) {
					// Email yes, Monthly, MonthsOfQuarterly no, IsOccursOnceAt yes, IsEndDate no
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "N" &&
					task.ScheduleTypeId === "Daily" &&
					task.EveryXDays.length > 0 &&
					task.IsOccursOnceAt === "Y" &&
					task.IsEndDate === "Y"
				) {
					// Email no, Daily, IsOccursOnceAt yes, IsEndDate yes
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "N" &&
					task.ScheduleTypeId === "Daily" &&
					task.EveryXDays.length > 0 &&
					task.IsOccursOnceAt === "N" &&
					task.EveryXminutes.length > 0 &&
					task.IsEndDate === "Y"
				) {
					// Email no, Daily, IsOccursOnceAt no, IsEndDate yes
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "N" &&
					task.ScheduleTypeId === "Weekly" &&
					task.EveryXWeeks.length > 0 &&
					task.ScheduleWeekday.length > 0 &&
					task.IsOccursOnceAt === "Y" &&
					task.IsEndDate === "Y"
				) {
					// Email no, Weekly, IsOccursOnceAt yes, IsEndDate yes
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "N" &&
					task.ScheduleTypeId === "Weekly" &&
					task.EveryXWeeks.length > 0 &&
					task.ScheduleWeekday.length > 0 &&
					task.IsOccursOnceAt === "N" &&
					task.EveryXminutes.length > 0 &&
					task.IsEndDate === "Y"
				) {
					// Email no, Weekly, IsOccursOnceAt no, IsEndDate yes
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "N" &&
					task.ScheduleTypeId === "Monthly" &&
					task.DaysOfMonth === "Y" &&
					task.DayOfMonth.length > 0 &&
					task.EveryXMonths.length > 0 &&
					task.IsOccursOnceAt === "Y" &&
					task.IsEndDate === "Y"
				) {
					// Email no, Monthly, DaysOfMonth yes, IsOccursOnceAt yes, IsEndDate yes
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "N" &&
					task.ScheduleTypeId === "Monthly" &&
					task.DaysOfMonth === "Y" &&
					task.DayOfMonth.length > 0 &&
					task.EveryXMonths.length > 0 &&
					task.IsOccursOnceAt === "N" &&
					task.EveryXminutes.length > 0 &&
					task.IsEndDate === "Y"
				) {
					// Email no, Monthly, DaysOfMonth yes, IsOccursOnceAt no, IsEndDate yes
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "N" &&
					task.ScheduleTypeId === "Monthly" &&
					task.DaysOfMonth === "N" &&
					task.EveryXMonths2.length > 0 &&
					task.IsOccursOnceAt === "Y" &&
					task.IsEndDate === "Y"
				) {
					// Email no, Monthly, DaysOfMonth no, IsOccursOnceAt yes, IsEndDate yes
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "N" &&
					task.ScheduleTypeId === "Monthly" &&
					task.DaysOfMonth === "N" &&
					task.EveryXMonths2.length > 0 &&
					task.IsOccursOnceAt === "N" &&
					task.EveryXminutes.length > 0 &&
					task.IsEndDate === "Y"
				) {
					// Email no, Monthly, DaysOfMonth no, IsOccursOnceAt yes, IsEndDate yes
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "N" &&
					task.ScheduleTypeId === "Quarterly" &&
					task.MonthsOfQuarterly === "Y" &&
					task.DayOfQuarterlyMonth.length > 0 &&
					task.EveryXQuarterlyMonths.length > 0 &&
					task.IsOccursOnceAt === "Y" &&
					task.IsEndDate === "Y"
				) {
					// Email no, Monthly, MonthsOfQuarterly yes, IsOccursOnceAt yes, IsEndDate yes
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "N" &&
					task.ScheduleTypeId === "Quarterly" &&
					task.MonthsOfQuarterly === "Y" &&
					task.DayOfQuarterlyMonth.length > 0 &&
					task.EveryXQuarterlyMonths.length > 0 &&
					task.IsOccursOnceAt === "N" &&
					task.EveryXminutes.length > 0 &&
					task.IsEndDate === "Y"
				) {
					// Email no, Monthly, MonthsOfQuarterly yes, IsOccursOnceAt no, IsEndDate yes
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "N" &&
					task.ScheduleTypeId === "Quarterly" &&
					task.MonthsOfQuarterly === "N" &&
					task.EveryXQuarterlyMonths2.length > 0 &&
					task.IsOccursOnceAt === "Y" &&
					task.IsEndDate === "Y"
				) {
					// Email no, Monthly, MonthsOfQuarterly no, IsOccursOnceAt yes, IsEndDate yes
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "N" &&
					task.ScheduleTypeId === "Quarterly" &&
					task.MonthsOfQuarterly === "N" &&
					task.EveryXQuarterlyMonths2.length > 0 &&
					task.IsOccursOnceAt === "N" &&
					task.EveryXminutes.length > 0 &&
					task.IsEndDate === "Y"
				) {
					// Email no, Monthly, MonthsOfQuarterly no, IsOccursOnceAt yes, IsEndDate yes
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "N" &&
					task.ScheduleTypeId === "Daily" &&
					task.EveryXDays.length > 0 &&
					task.IsOccursOnceAt === "Y" &&
					task.IsEndDate === "N"
				) {
					// Email no, Daily, IsOccursOnceAt yes, IsEndDate no
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "N" &&
					task.ScheduleTypeId === "Daily" &&
					task.EveryXDays.length > 0 &&
					task.IsOccursOnceAt === "N" &&
					task.EveryXminutes.length > 0 &&
					task.IsEndDate === "N"
				) {
					// Email no, Daily, IsOccursOnceAt no, IsEndDate no
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "N" &&
					task.ScheduleTypeId === "Weekly" &&
					task.EveryXWeeks.length > 0 &&
					task.ScheduleWeekday.length > 0 &&
					task.IsOccursOnceAt === "Y" &&
					task.IsEndDate === "N"
				) {
					// Email no, Weekly, IsOccursOnceAt yes, IsEndDate no
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "N" &&
					task.ScheduleTypeId === "Weekly" &&
					task.EveryXWeeks.length > 0 &&
					task.ScheduleWeekday.length > 0 &&
					task.IsOccursOnceAt === "N" &&
					task.EveryXminutes.length > 0 &&
					task.IsEndDate === "N"
				) {
					// Email no, Weekly, IsOccursOnceAt no, IsEndDate no
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "N" &&
					task.ScheduleTypeId === "Monthly" &&
					task.DaysOfMonth === "Y" &&
					task.DayOfMonth.length > 0 &&
					task.EveryXMonths.length > 0 &&
					task.IsOccursOnceAt === "Y" &&
					task.IsEndDate === "N"
				) {
					// Email no, Monthly, DaysOfMonth yes, IsOccursOnceAt yes, IsEndDate no
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "N" &&
					task.ScheduleTypeId === "Monthly" &&
					task.DaysOfMonth === "Y" &&
					task.DayOfMonth.length > 0 &&
					task.EveryXMonths.length > 0 &&
					task.IsOccursOnceAt === "N" &&
					task.EveryXminutes.length > 0 &&
					task.IsEndDate === "N"
				) {
					// Email no, Monthly, DaysOfMonth yes, IsOccursOnceAt no, IsEndDate no
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "N" &&
					task.ScheduleTypeId === "Monthly" &&
					task.DaysOfMonth === "N" &&
					task.EveryXMonths2.length > 0 &&
					task.IsOccursOnceAt === "Y" &&
					task.IsEndDate === "N"
				) {
					// Email no, Monthly, DaysOfMonth no, IsOccursOnceAt yes, IsEndDate no
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "N" &&
					task.ScheduleTypeId === "Monthly" &&
					task.DaysOfMonth === "N" &&
					task.EveryXMonths2.length > 0 &&
					task.IsOccursOnceAt === "N" &&
					task.EveryXminutes.length > 0 &&
					task.IsEndDate === "N"
				) {
					// Email no, Monthly, DaysOfMonth no, IsOccursOnceAt yes, IsEndDate no
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "N" &&
					task.ScheduleTypeId === "Quarterly" &&
					task.MonthsOfQuarterly === "Y" &&
					task.DayOfQuarterlyMonth.length > 0 &&
					task.EveryXQuarterlyMonths.length > 0 &&
					task.IsOccursOnceAt === "Y" &&
					task.IsEndDate === "N"
				) {
					// Email no, Quarterly, MonthsOfQuarterly yes, IsOccursOnceAt yes, IsEndDate no
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "N" &&
					task.ScheduleTypeId === "Quarterly" &&
					task.MonthsOfQuarterly === "Y" &&
					task.DayOfQuarterlyMonth.length > 0 &&
					task.EveryXQuarterlyMonths.length > 0 &&
					task.IsOccursOnceAt === "N" &&
					task.EveryXminutes.length > 0 &&
					task.IsEndDate === "N"
				) {
					// Email no, Quarterly, MonthsOfQuarterly yes, IsOccursOnceAt no, IsEndDate no
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "N" &&
					task.ScheduleTypeId === "Quarterly" &&
					task.MonthsOfQuarterly === "N" &&
					task.EveryXQuarterlyMonths2.length > 0 &&
					task.IsOccursOnceAt === "Y" &&
					task.IsEndDate === "N"
				) {
					// Email no, Quarterly, MonthsOfQuarterly no, IsOccursOnceAt yes, IsEndDate no
					setSubmitBtnDisable(false);
				} else if (
					task.ClientId !== "Select Client" &&
					task.FileTypeId !== "Select File" &&
					task.FileFormatId !== "Select File Format" &&
					task.EDITaskTypeId !== "Select Task Type" &&
					task.TaskName.length > 1 &&
					task.FileNameFormat.length > 0 &&
					task.File_Receive_Path.length > 0 &&
					task.SuccessArchivePath.length > 0 &&
					task.FailureArchivePath.length > 0 &&
					task.ReadTries.length > 0 &&
					task.Notify === "N" &&
					task.ScheduleTypeId === "Quarterly" &&
					task.MonthsOfQuarterly === "N" &&
					task.EveryXQuarterlyMonths2.length > 0 &&
					task.IsOccursOnceAt === "N" &&
					task.EveryXminutes.length > 0 &&
					task.IsEndDate === "N"
				) {
					// Email no, Quarterly, MonthsOfQuarterly no, IsOccursOnceAt yes, IsEndDate no
					setSubmitBtnDisable(false);
				} else {
					setSubmitBtnDisable(true);
				}
			} else {
				setSubmitBtnDisable(true);
			}
			if (editingTask) {
				setSubmitBtnDisable(false);
			}
		} else if (task.FileSourceTypeId === "Outbound") {
			setInbound(false);
			setOutbound(true);

			if (!editingTask) {
				if (task.OutboundResponsePath !== null) {
					// Button enable
					if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "Y" &&
						task.NotifyEmail.length > 0 &&
						task.ScheduleTypeId === "Daily" &&
						task.EveryXDays.length > 0 &&
						task.IsOccursOnceAt === "Y" &&
						task.IsEndDate === "Y"
					) {
						// Email yes, Daily, IsOccursOnceAt yes, IsEndDate yes
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "Y" &&
						task.NotifyEmail.length > 0 &&
						task.ScheduleTypeId === "Daily" &&
						task.EveryXDays.length > 0 &&
						task.IsOccursOnceAt === "N" &&
						task.EveryXminutes.length > 0 &&
						task.IsEndDate === "Y"
					) {
						// Email yes, Daily, IsOccursOnceAt no, IsEndDate yes
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "Y" &&
						task.NotifyEmail.length > 0 &&
						task.ScheduleTypeId === "Weekly" &&
						task.EveryXWeeks.length > 0 &&
						task.ScheduleWeekday.length > 0 &&
						task.IsOccursOnceAt === "Y" &&
						task.IsEndDate === "Y"
					) {
						// Email yes, Weekly, IsOccursOnceAt yes, IsEndDate yes
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "Y" &&
						task.NotifyEmail.length > 0 &&
						task.ScheduleTypeId === "Weekly" &&
						task.EveryXWeeks.length > 0 &&
						task.ScheduleWeekday.length > 0 &&
						task.IsOccursOnceAt === "N" &&
						task.EveryXminutes.length > 0 &&
						task.IsEndDate === "Y"
					) {
						// Email yes, Weekly, IsOccursOnceAt no, IsEndDate yes
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "Y" &&
						task.NotifyEmail.length > 0 &&
						task.ScheduleTypeId === "Monthly" &&
						task.DaysOfMonth === "Y" &&
						task.DayOfMonth.length > 0 &&
						task.EveryXMonths.length > 0 &&
						task.IsOccursOnceAt === "Y" &&
						task.IsEndDate === "Y"
					) {
						// Email yes, Monthly, DaysOfMonth yes, IsOccursOnceAt yes, IsEndDate yes
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "Y" &&
						task.NotifyEmail.length > 0 &&
						task.ScheduleTypeId === "Monthly" &&
						task.DaysOfMonth === "Y" &&
						task.DayOfMonth.length > 0 &&
						task.EveryXMonths.length > 0 &&
						task.IsOccursOnceAt === "N" &&
						task.EveryXminutes.length > 0 &&
						task.IsEndDate === "Y"
					) {
						// Email yes, Monthly, DaysOfMonth yes, IsOccursOnceAt no, IsEndDate yes
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "Y" &&
						task.NotifyEmail.length > 0 &&
						task.ScheduleTypeId === "Monthly" &&
						task.DaysOfMonth === "N" &&
						task.EveryXMonths2.length > 0 &&
						task.IsOccursOnceAt === "Y" &&
						task.IsEndDate === "Y"
					) {
						// Email yes, Monthly, DaysOfMonth no, IsOccursOnceAt yes, IsEndDate yes
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "Y" &&
						task.NotifyEmail.length > 0 &&
						task.ScheduleTypeId === "Monthly" &&
						task.DaysOfMonth === "N" &&
						task.EveryXMonths2.length > 0 &&
						task.IsOccursOnceAt === "N" &&
						task.EveryXminutes.length > 0 &&
						task.IsEndDate === "Y"
					) {
						// Email yes, Monthly, DaysOfMonth no, IsOccursOnceAt no, IsEndDate yes
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "Y" &&
						task.NotifyEmail.length > 0 &&
						task.ScheduleTypeId === "Quarterly" &&
						task.MonthsOfQuarterly === "Y" &&
						task.DayOfQuarterlyMonth.length > 0 &&
						task.EveryXQuarterlyMonths.length > 0 &&
						task.IsOccursOnceAt === "Y" &&
						task.IsEndDate === "Y"
					) {
						// Email yes, Quarterly, MonthsOfQuarterly yes, IsOccursOnceAt yes, IsEndDate yes
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "Y" &&
						task.NotifyEmail.length > 0 &&
						task.ScheduleTypeId === "Quarterly" &&
						task.MonthsOfQuarterly === "Y" &&
						task.DayOfQuarterlyMonth.length > 0 &&
						task.EveryXQuarterlyMonths.length > 0 &&
						task.IsOccursOnceAt === "N" &&
						task.EveryXminutes.length > 0 &&
						task.IsEndDate === "Y"
					) {
						// Email yes, Quarterly, MonthsOfQuarterly yes, IsOccursOnceAt no, IsEndDate yes
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "Y" &&
						task.NotifyEmail.length > 0 &&
						task.ScheduleTypeId === "Quarterly" &&
						task.MonthsOfQuarterly === "N" &&
						task.EveryXQuarterlyMonths2.length > 0 &&
						task.IsOccursOnceAt === "Y" &&
						task.IsEndDate === "Y"
					) {
						// Email yes, Quarterly, MonthsOfQuarterly no, IsOccursOnceAt yes, IsEndDate yes
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "Y" &&
						task.NotifyEmail.length > 0 &&
						task.ScheduleTypeId === "Quarterly" &&
						task.MonthsOfQuarterly === "N" &&
						task.EveryXQuarterlyMonths2.length > 0 &&
						task.IsOccursOnceAt === "N" &&
						task.EveryXminutes.length > 0 &&
						task.IsEndDate === "Y"
					) {
						// Email yes, Quarterly, MonthsOfQuarterly no, IsOccursOnceAt no, IsEndDate yes
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "Y" &&
						task.NotifyEmail.length > 0 &&
						task.ScheduleTypeId === "Daily" &&
						task.EveryXDays.length > 0 &&
						task.IsOccursOnceAt === "Y" &&
						task.IsEndDate === "N"
					) {
						// Email yes, Daily, IsOccursOnceAt yes, IsEndDate no
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "Y" &&
						task.NotifyEmail.length > 0 &&
						task.ScheduleTypeId === "Daily" &&
						task.EveryXDays.length > 0 &&
						task.IsOccursOnceAt === "N" &&
						task.EveryXminutes.length > 0 &&
						task.IsEndDate === "N"
					) {
						// Email yes, Daily, IsOccursOnceAt no, IsEndDate no
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "Y" &&
						task.NotifyEmail.length > 0 &&
						task.ScheduleTypeId === "Weekly" &&
						task.EveryXWeeks.length > 0 &&
						task.ScheduleWeekday.length > 0 &&
						task.IsOccursOnceAt === "Y" &&
						task.IsEndDate === "N"
					) {
						// Email yes, Weekly, IsOccursOnceAt yes, IsEndDate no
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "Y" &&
						task.NotifyEmail.length > 0 &&
						task.ScheduleTypeId === "Weekly" &&
						task.EveryXWeeks.length > 0 &&
						task.ScheduleWeekday.length > 0 &&
						task.IsOccursOnceAt === "N" &&
						task.EveryXminutes.length > 0 &&
						task.IsEndDate === "N"
					) {
						// Email yes, Weekly, IsOccursOnceAt no, IsEndDate no
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "Y" &&
						task.NotifyEmail.length > 0 &&
						task.ScheduleTypeId === "Monthly" &&
						task.DaysOfMonth === "Y" &&
						task.DayOfMonth.length > 0 &&
						task.EveryXMonths.length > 0 &&
						task.IsOccursOnceAt === "Y" &&
						task.IsEndDate === "N"
					) {
						// Email yes, Monthly, DaysOfMonth yes, IsOccursOnceAt yes, IsEndDate no
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "Y" &&
						task.NotifyEmail.length > 0 &&
						task.ScheduleTypeId === "Monthly" &&
						task.DaysOfMonth === "Y" &&
						task.DayOfMonth.length > 0 &&
						task.EveryXMonths.length > 0 &&
						task.IsOccursOnceAt === "N" &&
						task.EveryXminutes.length > 0 &&
						task.IsEndDate === "N"
					) {
						// Email yes, Monthly, DaysOfMonth yes, IsOccursOnceAt no, IsEndDate no
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "Y" &&
						task.NotifyEmail.length > 0 &&
						task.ScheduleTypeId === "Monthly" &&
						task.DaysOfMonth === "N" &&
						task.EveryXMonths2.length > 0 &&
						task.IsOccursOnceAt === "Y" &&
						task.IsEndDate === "N"
					) {
						// Email yes, Monthly, DaysOfMonth no, IsOccursOnceAt yes, IsEndDate no
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "Y" &&
						task.NotifyEmail.length > 0 &&
						task.ScheduleTypeId === "Monthly" &&
						task.DaysOfMonth === "N" &&
						task.EveryXMonths2.length > 0 &&
						task.IsOccursOnceAt === "N" &&
						task.EveryXminutes.length > 0 &&
						task.IsEndDate === "N"
					) {
						// Email yes, Monthly, DaysOfMonth no, IsOccursOnceAt yes, IsEndDate no
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "Y" &&
						task.NotifyEmail.length > 0 &&
						task.ScheduleTypeId === "Quarterly" &&
						task.MonthsOfQuarterly === "Y" &&
						task.DayOfQuarterlyMonth.length > 0 &&
						task.EveryXQuarterlyMonths.length > 0 &&
						task.IsOccursOnceAt === "Y" &&
						task.IsEndDate === "N"
					) {
						// Email yes, Monthly, MonthsOfQuarterly yes, IsOccursOnceAt yes, IsEndDate no
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "Y" &&
						task.NotifyEmail.length > 0 &&
						task.ScheduleTypeId === "Quarterly" &&
						task.MonthsOfQuarterly === "Y" &&
						task.DayOfQuarterlyMonth.length > 0 &&
						task.EveryXQuarterlyMonths.length > 0 &&
						task.IsOccursOnceAt === "N" &&
						task.EveryXminutes.length > 0 &&
						task.IsEndDate === "N"
					) {
						// Email yes, Monthly, MonthsOfQuarterly yes, IsOccursOnceAt no, IsEndDate no
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "Y" &&
						task.NotifyEmail.length > 0 &&
						task.ScheduleTypeId === "Quarterly" &&
						task.MonthsOfQuarterly === "N" &&
						task.EveryXQuarterlyMonths2.length > 0 &&
						task.IsOccursOnceAt === "Y" &&
						task.IsEndDate === "N"
					) {
						// Email yes, Monthly, MonthsOfQuarterly no, IsOccursOnceAt yes, IsEndDate no
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "Y" &&
						task.NotifyEmail.length > 0 &&
						task.ScheduleTypeId === "Quarterly" &&
						task.MonthsOfQuarterly === "N" &&
						task.EveryXQuarterlyMonths2.length > 0 &&
						task.IsOccursOnceAt === "N" &&
						task.EveryXminutes.length > 0 &&
						task.IsEndDate === "N"
					) {
						// Email yes, Monthly, MonthsOfQuarterly no, IsOccursOnceAt yes, IsEndDate no
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "N" &&
						task.ScheduleTypeId === "Daily" &&
						task.EveryXDays.length > 0 &&
						task.IsOccursOnceAt === "Y" &&
						task.IsEndDate === "Y"
					) {
						// Email no, Daily, IsOccursOnceAt yes, IsEndDate yes
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "N" &&
						task.ScheduleTypeId === "Daily" &&
						task.EveryXDays.length > 0 &&
						task.IsOccursOnceAt === "N" &&
						task.EveryXminutes.length > 0 &&
						task.IsEndDate === "Y"
					) {
						// Email no, Daily, IsOccursOnceAt no, IsEndDate yes
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "N" &&
						task.ScheduleTypeId === "Weekly" &&
						task.EveryXWeeks.length > 0 &&
						task.ScheduleWeekday.length > 0 &&
						task.IsOccursOnceAt === "Y" &&
						task.IsEndDate === "Y"
					) {
						// Email no, Weekly, IsOccursOnceAt yes, IsEndDate yes
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "N" &&
						task.ScheduleTypeId === "Weekly" &&
						task.EveryXWeeks.length > 0 &&
						task.ScheduleWeekday.length > 0 &&
						task.IsOccursOnceAt === "N" &&
						task.EveryXminutes.length > 0 &&
						task.IsEndDate === "Y"
					) {
						// Email no, Weekly, IsOccursOnceAt no, IsEndDate yes
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "N" &&
						task.ScheduleTypeId === "Monthly" &&
						task.DaysOfMonth === "Y" &&
						task.DayOfMonth.length > 0 &&
						task.EveryXMonths.length > 0 &&
						task.IsOccursOnceAt === "Y" &&
						task.IsEndDate === "Y"
					) {
						// Email no, Monthly, DaysOfMonth yes, IsOccursOnceAt yes, IsEndDate yes
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "N" &&
						task.ScheduleTypeId === "Monthly" &&
						task.DaysOfMonth === "Y" &&
						task.DayOfMonth.length > 0 &&
						task.EveryXMonths.length > 0 &&
						task.IsOccursOnceAt === "N" &&
						task.EveryXminutes.length > 0 &&
						task.IsEndDate === "Y"
					) {
						// Email no, Monthly, DaysOfMonth yes, IsOccursOnceAt no, IsEndDate yes
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "N" &&
						task.ScheduleTypeId === "Monthly" &&
						task.DaysOfMonth === "N" &&
						task.EveryXMonths2.length > 0 &&
						task.IsOccursOnceAt === "Y" &&
						task.IsEndDate === "Y"
					) {
						// Email no, Monthly, DaysOfMonth no, IsOccursOnceAt yes, IsEndDate yes
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "N" &&
						task.ScheduleTypeId === "Monthly" &&
						task.DaysOfMonth === "N" &&
						task.EveryXMonths2.length > 0 &&
						task.IsOccursOnceAt === "N" &&
						task.EveryXminutes.length > 0 &&
						task.IsEndDate === "Y"
					) {
						// Email no, Monthly, DaysOfMonth no, IsOccursOnceAt yes, IsEndDate yes
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "N" &&
						task.ScheduleTypeId === "Quarterly" &&
						task.MonthsOfQuarterly === "Y" &&
						task.DayOfQuarterlyMonth.length > 0 &&
						task.EveryXQuarterlyMonths.length > 0 &&
						task.IsOccursOnceAt === "Y" &&
						task.IsEndDate === "Y"
					) {
						// Email no, Monthly, MonthsOfQuarterly yes, IsOccursOnceAt yes, IsEndDate yes
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "N" &&
						task.ScheduleTypeId === "Quarterly" &&
						task.MonthsOfQuarterly === "Y" &&
						task.DayOfQuarterlyMonth.length > 0 &&
						task.EveryXQuarterlyMonths.length > 0 &&
						task.IsOccursOnceAt === "N" &&
						task.EveryXminutes.length > 0 &&
						task.IsEndDate === "Y"
					) {
						// Email no, Monthly, MonthsOfQuarterly yes, IsOccursOnceAt no, IsEndDate yes
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "N" &&
						task.ScheduleTypeId === "Quarterly" &&
						task.MonthsOfQuarterly === "N" &&
						task.EveryXQuarterlyMonths2.length > 0 &&
						task.IsOccursOnceAt === "Y" &&
						task.IsEndDate === "Y"
					) {
						// Email no, Monthly, MonthsOfQuarterly no, IsOccursOnceAt yes, IsEndDate yes
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "N" &&
						task.ScheduleTypeId === "Quarterly" &&
						task.MonthsOfQuarterly === "N" &&
						task.EveryXQuarterlyMonths2.length > 0 &&
						task.IsOccursOnceAt === "N" &&
						task.EveryXminutes.length > 0 &&
						task.IsEndDate === "Y"
					) {
						// Email no, Monthly, MonthsOfQuarterly no, IsOccursOnceAt yes, IsEndDate yes
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "N" &&
						task.ScheduleTypeId === "Daily" &&
						task.EveryXDays.length > 0 &&
						task.IsOccursOnceAt === "Y" &&
						task.IsEndDate === "N"
					) {
						// Email no, Daily, IsOccursOnceAt yes, IsEndDate no
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "N" &&
						task.ScheduleTypeId === "Daily" &&
						task.EveryXDays.length > 0 &&
						task.IsOccursOnceAt === "N" &&
						task.EveryXminutes.length > 0 &&
						task.IsEndDate === "N"
					) {
						// Email no, Daily, IsOccursOnceAt no, IsEndDate no
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "N" &&
						task.ScheduleTypeId === "Weekly" &&
						task.EveryXWeeks.length > 0 &&
						task.ScheduleWeekday.length > 0 &&
						task.IsOccursOnceAt === "Y" &&
						task.IsEndDate === "N"
					) {
						// Email no, Weekly, IsOccursOnceAt yes, IsEndDate no
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "N" &&
						task.ScheduleTypeId === "Weekly" &&
						task.EveryXWeeks.length > 0 &&
						task.ScheduleWeekday.length > 0 &&
						task.IsOccursOnceAt === "N" &&
						task.EveryXminutes.length > 0 &&
						task.IsEndDate === "N"
					) {
						// Email no, Weekly, IsOccursOnceAt no, IsEndDate no
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "N" &&
						task.ScheduleTypeId === "Monthly" &&
						task.DaysOfMonth === "Y" &&
						task.DayOfMonth.length > 0 &&
						task.EveryXMonths.length > 0 &&
						task.IsOccursOnceAt === "Y" &&
						task.IsEndDate === "N"
					) {
						// Email no, Monthly, DaysOfMonth yes, IsOccursOnceAt yes, IsEndDate no
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "N" &&
						task.ScheduleTypeId === "Monthly" &&
						task.DaysOfMonth === "Y" &&
						task.DayOfMonth.length > 0 &&
						task.EveryXMonths.length > 0 &&
						task.IsOccursOnceAt === "N" &&
						task.EveryXminutes.length > 0 &&
						task.IsEndDate === "N"
					) {
						// Email no, Monthly, DaysOfMonth yes, IsOccursOnceAt no, IsEndDate no
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "N" &&
						task.ScheduleTypeId === "Monthly" &&
						task.DaysOfMonth === "N" &&
						task.EveryXMonths2.length > 0 &&
						task.IsOccursOnceAt === "Y" &&
						task.IsEndDate === "N"
					) {
						// Email no, Monthly, DaysOfMonth no, IsOccursOnceAt yes, IsEndDate no
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "N" &&
						task.ScheduleTypeId === "Monthly" &&
						task.DaysOfMonth === "N" &&
						task.EveryXMonths2.length > 0 &&
						task.IsOccursOnceAt === "N" &&
						task.EveryXminutes.length > 0 &&
						task.IsEndDate === "N"
					) {
						// Email no, Monthly, DaysOfMonth no, IsOccursOnceAt yes, IsEndDate no
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "N" &&
						task.ScheduleTypeId === "Quarterly" &&
						task.MonthsOfQuarterly === "Y" &&
						task.DayOfQuarterlyMonth.length > 0 &&
						task.EveryXQuarterlyMonths.length > 0 &&
						task.IsOccursOnceAt === "Y" &&
						task.IsEndDate === "N"
					) {
						// Email no, Quarterly, MonthsOfQuarterly yes, IsOccursOnceAt yes, IsEndDate no
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "N" &&
						task.ScheduleTypeId === "Quarterly" &&
						task.MonthsOfQuarterly === "Y" &&
						task.DayOfQuarterlyMonth.length > 0 &&
						task.EveryXQuarterlyMonths.length > 0 &&
						task.IsOccursOnceAt === "N" &&
						task.EveryXminutes.length > 0 &&
						task.IsEndDate === "N"
					) {
						// Email no, Quarterly, MonthsOfQuarterly yes, IsOccursOnceAt no, IsEndDate no
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "N" &&
						task.ScheduleTypeId === "Quarterly" &&
						task.MonthsOfQuarterly === "N" &&
						task.EveryXQuarterlyMonths2.length > 0 &&
						task.IsOccursOnceAt === "Y" &&
						task.IsEndDate === "N"
					) {
						// Email no, Quarterly, MonthsOfQuarterly no, IsOccursOnceAt yes, IsEndDate no
						setContinueBtnDisable(false);
					} else if (
						task.ClientId !== "Select Client" &&
						task.FileTypeId !== "Select File" &&
						task.FileFormatId !== "Select File Format" &&
						task.EDITaskTypeId !== "Select Task Type" &&
						task.TaskName.length > 1 &&
						task.FileNameFormat.length > 0 &&
						task.OutboundResponsePath.length > 0 &&
						task.SuccessArchivePath.length > 0 &&
						task.FailureArchivePath.length > 0 &&
						task.Notify === "N" &&
						task.ScheduleTypeId === "Quarterly" &&
						task.MonthsOfQuarterly === "N" &&
						task.EveryXQuarterlyMonths2.length > 0 &&
						task.IsOccursOnceAt === "N" &&
						task.EveryXminutes.length > 0 &&
						task.IsEndDate === "N"
					) {
						// Email no, Quarterly, MonthsOfQuarterly no, IsOccursOnceAt yes, IsEndDate no
						setContinueBtnDisable(false);
					} else {
						setContinueBtnDisable(true);
					}
				}
			} else {
				setContinueBtnDisable(true);
			}
			if (editingTask) {
				setContinueBtnDisable(false);
			}
		} else {
			setInbound(false);
			setOutbound(false);
		}

		if (task.Notify === "Y") {
			setNotify(true);
		} else {
			setNotify(false);
		}

		// Schedule Type
		if (task.ScheduleTypeId === "Daily") {
			setScheduleTypeDaily(true);
			setScheduleTypeWeekly(false);
			setScheduleTypeMonthly(false);
			setScheduleTypeQuarterly(false);
		} else if (task.ScheduleTypeId === "Weekly") {
			setScheduleTypeDaily(false);
			setScheduleTypeWeekly(true);
			setScheduleTypeMonthly(false);
			setScheduleTypeQuarterly(false);
		} else if (task.ScheduleTypeId === "Monthly") {
			setScheduleTypeDaily(false);
			setScheduleTypeWeekly(false);
			setScheduleTypeMonthly(true);
			setScheduleTypeQuarterly(false);
		} else if (task.ScheduleTypeId === "Quarterly") {
			setScheduleTypeDaily(false);
			setScheduleTypeWeekly(false);
			setScheduleTypeMonthly(false);
			setScheduleTypeQuarterly(true);
		} else {
			setScheduleTypeDaily(false);
			setScheduleTypeWeekly(false);
			setScheduleTypeMonthly(false);
			setScheduleTypeQuarterly(false);
		}

		if (task.IsOccursOnceAt === "Y") {
			setOccursEveryInputDisable(true);
			setOccursOnceAtInputDisable(false);
		} else {
			setOccursEveryInputDisable(false);
			setOccursOnceAtInputDisable(true);
		}

		if (task.DaysOfMonth === "Y") {
			setDayXMonthsDisable(false);
			setTheXMonthsDisable(true);
		} else {
			setDayXMonthsDisable(true);
			setTheXMonthsDisable(false);
		}

		// Monthly Months of Quarterly
		if (task.MonthsOfQuarterly === "Y") {
			setMonthXQuarterlyDisable(false);
			setTheXQuarterlyDisable(true);
		} else {
			setMonthXQuarterlyDisable(true);
			setTheXQuarterlyDisable(false);
		}

		if (task.IsEndDate === "N") {
			setIsEndDateDisable(true);
			setEndDate(new Date("01/01/3000"));
		} else {
			setIsEndDateDisable(false);
		}
	};

	// ======================================================================================================= Submit Handler ============
	const submitHandler = async (e) => {
		// e.preventDefault()

		if (!editingTask) {
			if (
				tasks.length > 0 &&
				tasks.find((item) => item.TaskName === task.TaskName)
			) {
				setTaskNameError(true);
				return false;
			}
		}
		if (occursEveryStartTime > occursEveryEndTime) {
			setStartTimeGreaterErr(true);
			return false;
		}
		if (task.IsEndDate === "Y") {
			if (startDate > endDate) {
				setLoader(false);
				setStartDateGreaterErr(true);
				return false;
			}
			// return false
		}
		if (task.StartDate === "") {
			setStartDateErr(true);
			return false;
		}
		// Email validation
		if (task.NotifyEmail) {
			if (task.NotifyEmail.length > 0) {
				let emailValue = task.NotifyEmail;
				const regEx = /^([a-zA-Z0-9._-]+@([a-zA-Z]+\.)+[a-zA-Z]{2,4})?$/;
				let result = emailValue.replace(/\s/g, "").split(/,|;/);

				for (var i = 0; i < result.length; i++) {
					if (regEx.test(result[i])) {
						setEmailErr(0);
						setErrEmail(false);
						task.NotifyEmail = emailValue;
					} else {
						setEmailErr(1);
						setErrEmail(true);
						return false;
					}
				}
			}
		}

		// Enable Loader
		// setLoader(true);

		let TaskClientId = "";
		if (taskDropdownLists.length > 0) {
			taskDropdownLists[0].Client.map((client) => {
				if (client.ClientName === task.ClientId) {
					TaskClientId = client.Id;
				}
			});
		}

		let TaskFileSourceTypeId = "";
		if (taskDropdownLists.length > 0) {
			taskDropdownLists[0].FileSourceTypeList.map((source) => {
				if (source.FileSourceName === task.FileSourceTypeId) {
					TaskFileSourceTypeId = source.Id;
				}
			});
		}

		let TaskFileTypeId = "";
		if (taskDropdownLists.length > 0) {
			taskDropdownLists[0].FileTypesList.map((file) => {
				if (file.FileTypeName === task.FileTypeId) {
					TaskFileTypeId = file.Id;
				}
			});
		}

		let TaskFileFormatId = "";
		if (taskDropdownLists.length > 0) {
			taskDropdownLists[0].FileFormatList.map((file) => {
				if (file.FileFormatName === task.FileFormatId) {
					TaskFileFormatId = file.Id;
				}
			});
		}

		let TaskEDITaskTypeId = "";
		if (taskDropdownLists.length > 0) {
			taskDropdownLists[0].EdiTaskTypesList.map((type) => {
				if (type.TaskTypeDescription === task.EDITaskTypeId) {
					TaskEDITaskTypeId = type.TaskTypeId;
				}
			});
		}

		let TaskScheduleTypeId = "";
		if (taskDropdownLists.length > 0) {
			taskDropdownLists[0].SchdulerType.map((schedule) => {
				if (schedule.ScheduleType === task.ScheduleTypeId) {
					TaskScheduleTypeId = schedule.Id;
				}
			});
		}

		let TaskMonthlySpecificDatePartOneId = "";
		if (taskDropdownLists.length > 0) {
			taskDropdownLists[0].MonthlySpecificDatePartOneList.map((list) => {
				if (list.value === task.MonthlySpecificDatePartOne) {
					TaskMonthlySpecificDatePartOneId = list.data;
				}
			});
		}

		let TaskMonthlySpecificDatePartTwoId = "";
		if (taskDropdownLists.length > 0) {
			taskDropdownLists[0].MonthlySpecificDatePartTwoList.map((list) => {
				if (list.value === task.MonthlySpecificDatePartTwo) {
					TaskMonthlySpecificDatePartTwoId = list.data;
				}
			});
		}

		// Quarterly
		let TaskMonthOfQuarterlyId = "";
		if (taskDropdownLists.length > 0) {
			taskDropdownLists[0].QuarterlyMonths.map((item) => {
				if (item.value === task.MonthOfQuarterly) {
					TaskMonthOfQuarterlyId = item.data;
				}
			});
		}

		let TaskMonthOfQuarterly2Id = "";
		if (taskDropdownLists.length > 0) {
			taskDropdownLists[0].QuarterlyMonths.map((item) => {
				if (item.value === task.MonthOfQuarterly2) {
					TaskMonthOfQuarterly2Id = item.data;
				}
			});
		}

		let TaskQuarterlySpecificDatePartOneId = "";
		if (taskDropdownLists.length > 0) {
			taskDropdownLists[0].MonthlySpecificDatePartOneList.map((list) => {
				if (list.value === task.QuarterlySpecificDatePartOne) {
					TaskQuarterlySpecificDatePartOneId = list.data;
				}
			});
		}

		let TaskQuarterlySpecificDatePartTwoId = "";
		if (taskDropdownLists.length > 0) {
			taskDropdownLists[0].MonthlySpecificDatePartTwoList.map((list) => {
				if (list.value === task.QuarterlySpecificDatePartTwo) {
					TaskQuarterlySpecificDatePartTwoId = list.data;
				}
			});
		}

		let TaskTimeRecurrenceTypeId = "";
		if (taskDropdownLists.length > 0) {
			taskDropdownLists[0].TimeRecurrenceType.map((time) => {
				if (time.value === task.TimeRecurrenceTypeId) {
					TaskTimeRecurrenceTypeId = time.data;
				}
			});
		}

		let TaskNotify = "";
		if (task.Notify === "N") {
			TaskNotify = "";
		} else {
			TaskNotify = task.NotifyEmail;
		}

		let weeklyValues = [];
		if (task.ScheduleWeekday !== null && task.ScheduleWeekday !== undefined) {
			if (task.ScheduleWeekday.length > 0) {
				task.ScheduleWeekday.map((day) => {
					weeklyValues.push(day.label);
				});
			}
		}
		var weeklyDays = weeklyValues.join();

		let TaskOccursEverySpecificTime = "";
		let TaskOccursEveryStartTime = "";
		let TaskOccursEveryEndTime = "";

		if (task.IsOccursOnceAt === "Y") {
			TaskOccursEveryStartTime = "";
			TaskOccursEveryEndTime = "";
			TaskOccursEverySpecificTime = moment(occursOnceAt).format("hh:mm a");
		} else {
			TaskOccursEveryStartTime = moment(occursEveryStartTime).format("hh:mm a");
			TaskOccursEveryEndTime = moment(occursEveryEndTime).format("hh:mm a");
			TaskOccursEverySpecificTime = "";
		}

		if (task.DaysOfMonth === "N") {
			task.DayOfMonth = "";
			task.EveryXMonths = "";
		} else if (task.DaysOfMonth === "Y") {
			task.EveryXMonths2 = "";
		}

		if (TaskFileSourceTypeId === 2) {
			task.ReadTries = "1";
		}

		let TaskEndDate = "";
		if (task.IsEndDate === "N") {
			TaskEndDate = "";
			// TaskEndDate = new Date("01/01/3000")
			// setEndDate()
		} else {
			TaskEndDate = moment(endDate).format("L");
		}

		const modifiedTask = {
			...task,
			CreatedBy: userName,
			ModifiedBy: userName,
			Id: task.Id,
			ClientId: TaskClientId,
			FileSourceTypeId: TaskFileSourceTypeId,
			FileTypeId: TaskFileTypeId,
			FileFormatId: TaskFileFormatId,
			EDITaskTypeId: TaskEDITaskTypeId,
			ScheduleTypeId: TaskScheduleTypeId,
			TimeRecurrenceTypeId: TaskTimeRecurrenceTypeId,
			NotifyEmail: TaskNotify,
			EveryXDays: Number(task.EveryXDays),
			DayOfMonth: Number(task.DayOfMonth),
			ReadTries: Number(task.ReadTries),
			EveryXMonths: Number(task.EveryXMonths),
			EveryXMonths2: Number(task.EveryXMonths2),
			EveryXminutes: Number(task.EveryXminutes),
			SpecificTime: TaskOccursEverySpecificTime,
			EveryXWeeks: Number(task.EveryXWeeks),
			StartTime: TaskOccursEveryStartTime,
			EndTime: TaskOccursEveryEndTime,
			StartDate: moment(startDate).format("L"), //ScheduleDay : weekDays,
			ScheduleWeekday: weeklyDays,
			MonthlySpecificDatePartOne: TaskMonthlySpecificDatePartOneId,
			MonthlySpecificDatePartTwo: TaskMonthlySpecificDatePartTwoId,
			EndDate: TaskEndDate,
			OutboundResponsePath: task.OutboundResponsePath,
			DayOfQuarterlyMonth: Number(task.DayOfQuarterlyMonth),
			EveryXQuarterlyMonths: Number(task.EveryXQuarterlyMonths),
			EveryXQuarterlyMonths2: Number(task.EveryXQuarterlyMonths2),
			MonthOfQuarterly: TaskMonthOfQuarterlyId,
			MonthOfQuarterly2: TaskMonthOfQuarterly2Id,
			QuarterlySpecificDatePartOne: TaskQuarterlySpecificDatePartOneId,
			QuarterlySpecificDatePartTwo: TaskQuarterlySpecificDatePartTwoId,
			File_Receive_Path: task.File_Receive_Path,
			SuccessArchivePath: task.SuccessArchivePath,
			FailureArchivePath: task.FailureArchivePath,
		};
		if (config && editingTask) {
			await dispatch(updateContinueTask(modifiedTask));
			await dispatch(fetchEditTask(task.Id));
			// await mappingToTaskPrevTask(editTask);
		} else if (!config && editingTask) {
			await dispatch(updateTask(modifiedTask));
			cancelHandler();
		} else {
			await dispatch(addTask(modifiedTask));
			if (config) {
				setLoader(false);
			} else if (!config || adding) {
				cancelHandler();
				setLoader(false);
			}
		}

		if (!config) {
			setStopToaster(false);
			setRestartToaster(false);
			setStartToaster(false);
			setDeleteToaster(false);
			setenableTaskTaskoaster(false);
			setShowToaster(true);
			setLoader(false);
			// set
		}
		if (config && editingTask && outbound) {
			setTabActiveKey("CommunicationConfiguration");
			setSubmitBtnDisable(false);
			return false;
		} else if (config && editingTask && inbound) {
			setTabActiveKey("DataSecurity");
			setSubmitBtnDisable(false);
			return false;
		}
		if (config === true && !editingTask && outbound) {
			setTabActiveKey("CommunicationConfiguration");
			setSubmitBtnDisable(false);
		} else if (config === true && !editingTask && inbound) {
			setTabActiveKey("DataSecurity");
		} else if (!config && editingTask) {
			history.push("/task");
		}
		setEmailErr(2);
	};

	const addTaskSubmitHandler = (e) => {
		e.preventDefault();

		const form = e.currentTarget;
		if (form.checkValidity() === false) {
			e.preventDefault();
			e.stopPropagation();
		} else {
			e.preventDefault();
			submitHandler();
		}

		setValidated(true);
		setViewTask(false);
	};

	// Edit Task fn
	const editTaskHandler = (data) => {
		history.push("/task/" + data.Id + "/edit");
	};

	const editTaskSubmitHandler = async (e) => {
		e.preventDefault();

		const form = e.currentTarget;
		if (form.checkValidity() === false) {
			// e.preventDefault()
			e.stopPropagation();
		} else {
			// e.preventDefault()
			await submitHandler();
			// await setTabActiveKey('CommunicationConfiguration');
		}

		setValidated(true);
		setViewTask(false);
	};

	// Delete fn
	const deleteTaskHandler = () => {
		// setConfirmShowToaster(true);
		_HttpServices
			.postData(`api/services/DeleteTask?taskId=${DeleteTask.Id}`)
			.then((data) => {
				if (data) {
					// setConfirmShowToaster(false);
					setDeleteToaster(true);
					setRestartToaster(false);
					setStartToaster(false);
					setStopToaster(false);
					setShowConfirm(false);
					dispatch(fetchTasks());
					setShowToaster(true);
					setDeleteTask(null);
					setenableTaskTaskoaster(false);
				}
			})
			.catch((error) => {
				// setDeleteTask(null)
				setLoader(false);
			});
	};
	const enableTaskHandler = (task) => {
		setLoader(true);
		_HttpServices
			.postData(`Api/Services/EnableTask?taskId=${task.Id}`)
			.then((response) => {
				setLoader(false);
				setenableTaskTaskoaster(true);
				setDeleteToaster(false);
				setRestartToaster(false);
				setStartToaster(false);
				setStopToaster(false);
				setShowConfirm(false);
				dispatch(fetchTasks());
				setShowToaster(true);
			});
	};

	const stopTaskHandler = async (task) => {
		setLoader(true);
		setRestartToaster(false);
		await _HttpServices
			.getData(`api/services/StopServiceByName?taskId=${task.Id}`)
			.then((data) => {
				if (data) {
					setLoader(false);
					dispatch(fetchTasks());
					setStopToaster(true);
					setDeleteToaster(false);
					setenableTaskTaskoaster(false);
					setStartToaster(false);
					setRestartToaster(false);
					setShowToaster(true);
				}
			})
			.catch((error) => {
				setLoader(false);
			});
	};

	const restartTaskHandler = async (task) => {
		setLoader(true);
		setStopToaster(false);
		await _HttpServices
			.getData(`api/services/StartServiceByName?taskId=${task.Id}`)
			.then((data) => {
				if (data) {
					setLoader(false);
					dispatch(fetchTasks());
					setStartToaster(false);
					setShowToaster(true);
					setRestartToaster(true);
				}
			})
			.catch((error) => {
				setLoader(false);
			});
	};

	const startTaskHandler = async (task) => {
		setLoader(true);
		setStopToaster(false);
		await _HttpServices
			.getData(`api/services/StartServiceByName?taskId=${task.Id}`)
			.then((data) => {
				if (data) {
					setLoader(false);
					dispatch(fetchTasks());
					setStartToaster(true);
					setShowToaster(true);
				}
			})
			.catch((error) => {
				setLoader(false);
			});
	};

	const cancelHandler = async () => {
		setLoader(true);
		setShow(false);
		setEditing(false);
		setTask(initialState);
		setValidated(false);
		setAdding(false);
		setSubmitBtnDisable(true);
		setContinueBtnDisable(true);
		setViewTask(false);
		setOccursOnceAt(new Date());
		setOccursEveryStartTime(new Date());
		setOccursEveryEndTime(new Date());
		setStartDate(new Date());
		setEndDate(new Date());
		setErrEmail(false);
		setEmailErr(2);
		if (editingTask) {
			setEditDisable(false);
			await dispatch(cancelEditingTask());
			setTabActiveKey("TaskConfiguration");
			history.push("/task");
		}
		setTabActiveKey("TaskConfiguration");
		setLoader(false);
	};

	const viewTaskHandler = (row) => {
		history.push("/task/" + row.Id + "/view");
	};

	const submitForm = (e) => {
		e.preventDefault();
		if (!submitSaveOrUpdate) {
			editing ? editTaskSubmitHandler(e) : addTaskSubmitHandler(e);
		} else {
			config = true;
			navigateToConfiguration(e);
		}
	};
	// Communication configuration
	const navigateToConfiguration = async (e) => {
		config = true;
		e.preventDefault();

		const form = e.currentTarget;
		if (form.checkValidity() === false) {
			e.stopPropagation();
		} else {
			await submitHandler();
		}

		setValidated(true);
		setViewTask(false);
		setSubmitBtnDisable(false);
	};

	const columns = [
		{
			Header: "Actions",
			accessor: "accessor",
			disableFilters: true,
			disableSortBy: true,
			width: 130,
			Cell: ({ row: { original } }) => (
				<Fragment>
					{original.IsDeleted === "N" ? (
						<Fragment>
							{roleId === 1 ? (
								<Fragment>
									{/* <Fragment> */}
									{original.TaskStatusId === "New" ? (
										<Fragment>
											<Button
												variant="link"
												onClick={() => startTaskHandler(original)}
												className="grid-action-btn"
												title="Start Task"
											>
												<IoIosPlay className="icon" />
											</Button>
											<Button
												variant="link"
												onClick={() => editTaskHandler(original)}
												className="grid-action-btn ml-2"
												title="Edit Task"
											>
												<IoMdCreate className="icon" />
											</Button>
											<Button
												variant="link"
												onClick={() => deleteTask(original)}
												className="grid-action-btn ml-2"
												title="Disable Task"
											>
												<FaBan className="icon fa-icon" />
											</Button>
										</Fragment>
									) : null}
									{/* {original.TaskStatusId === "Pending" ? : null} */}
									{original.TaskStatusId === "Stop" ? (
										<Fragment>
											<Button
												variant="link"
												onClick={() => restartTaskHandler(original)}
												className="grid-action-btn"
												title="Restart Task"
											>
												<IoMdRefresh className="icon" />
											</Button>
											<Button
												variant="link"
												onClick={() => editTaskHandler(original)}
												className="grid-action-btn ml-2"
												title="Edit Task"
											>
												<IoMdCreate className="icon" />
											</Button>
											<Button
												variant="link"
												onClick={() => deleteTask(original)}
												className="grid-action-btn ml-2"
												title="Disable Task"
											>
												<FaBan className="icon fa-icon" />
											</Button>
										</Fragment>
									) : null}
									{original.TaskStatusId === "Running" ? (
										<Fragment>
											<Button
												variant="link"
												onClick={() => stopTaskHandler(original)}
												className="grid-action-btn"
												title="Stop Task"
											>
												<IoMdSquare className="icon" />
											</Button>
											<Button
												variant="link"
												onClick={() => viewTaskHandler(original)}
												className="grid-action-btn ml-2"
												title="View Task"
											>
												<IoIosEye className="icon" />
											</Button>
										</Fragment>
									) : null}

									{/* Windows service icon */}
									{original.IsServiceRunning ? null : (
										<OverlayTrigger
											key="service-running"
											placement="bottom"
											overlay={
												<Tooltip id="service-running">
													Windows Service is not running.
												</Tooltip>
											}
										>
											<Button
												variant="link"
												className="grid-action-btn ml-2 red-txt"
											>
												<IoMdSettings className="icon" />
											</Button>
										</OverlayTrigger>
									)}
								</Fragment>
							) : (
								<Fragment>
									<Button
										variant="link"
										onClick={() => viewTaskHandler(original)}
										className="grid-action-btn"
										title="View Task"
									>
										<IoIosEye className="icon" />
									</Button>
								</Fragment>
							)}
						</Fragment>
					) : (
						<Fragment>
							<Fragment>
								{roleId === 1 ? (
									<Button
										variant="link"
										onClick={() => enableTaskHandler(original)}
										className="grid-action-btn"
										title="Enable Task"
									>
										<IoIosBulb className="icon" />
									</Button>
								) : null}
							</Fragment>
							<Button
								variant="link"
								onClick={() => viewTaskHandler(original)}
								className="grid-action-btn ml-2"
								title="View Task"
							>
								<IoIosEye className="icon" />
							</Button>
						</Fragment>
					)}
				</Fragment>
			),
		},
		{
			Header: "Task Name",
			accessor: "TaskName",
			filter: "TaskName",
			sortType: "basic",
			width: 190,
		},
		// { Header: 'Client Name', accessor: 'ClientName', filter: 'ClientName', sortType: 'basic', width: 120 },
		{
			Header: "Schedule Type",
			accessor: "ScheduleType",
			filter: "ScheduleType",
			sortType: "basic",
			width: 130,
		},
		{
			Header: "Start Date",
			accessor: "StartDate",
			filter: "StartDate",
			sortType: "basic",
			width: 115,
		},
		{
			Header: "Description",
			accessor: "Description",
			filter: "Description",
			sortType: "basic",
			width: 250,
		},
		{
			Header: "File Source",
			accessor: "FileSourceTypeId",
			filter: "FileSourceTypeId",
			sortType: "basic",
			width: 100,
		},
		{
			Header: "Created Date",
			accessor: "CreatedDate",
			filter: "CreatedDate",
			sortType: "basic",
			width: 100,
		},
		{
			Header: "Modified Date",
			accessor: "ModifiedDate",
			filter: "ModifiedDate",
			sortType: "basic",
			width: 100,
		},
	];

	const options = [
		{ label: "Sunday", value: 1 },
		{ label: "Monday", value: 2 },
		{ label: "Tuesday", value: 3 },
		{ label: "Wednesday", value: 4 },
		{ label: "Thursday", value: 5 },
		{ label: "Friday", value: 6 },
		{ label: "Saturday", value: 7 },
	];

	return (
		<section className="content">
			<div className="page-title">
				<h2 className="h2">
					{adding
						? "Add Task"
						: editing
						? "Edit Task"
						: viewTask
						? "View Task"
						: "Task List"}
				</h2>
				<div>
					{roleId != 1 && roleId != 2 ? (
						show ? null : editing ? null : (
							<Button onClick={() => addTaskHandler()}>
								<IoIosAdd className="icon btn-icon" />
								Add Task
							</Button>
						)
					) : (
						""
					)}
					{show ? null : editing ? null : (
						<Button
							className="ml-2"
							onClick={() => getExcel(columns, tasks, fileName)}
						>
							<IoMdDownload className="icon btn-icon" />
							Download Excel
						</Button>
					)}
				</div>
				{/* Modal */}
				<Modal
					show={showCOnfirm}
					onHide={() => setShowConfirm(false)}
					backdrop="static"
					keyboard={false}
				>
					<Modal.Header closeButton>
						<Modal.Title>
							<img
								src="holder.js/20x20?text=%20"
								className="rounded mr-2"
								alt=""
							/>
							<strong>Confirm</strong>
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<p className="ml-2">Are you sure want to disable?</p>
					</Modal.Body>
					<Modal.Footer>
						{/* onClick={forgotPasswordHandle} */}
						<div className="text-right mt-2">
							<Button onClick={() => deleteTaskHandler()}>
								<IoMdDoneAll className="icon btn-icon" />
								Yes
							</Button>
							<Button
								variant="danger"
								className="ml-3 btn-sm"
								onClick={() => setShowConfirm(false)}
							>
								<IoIosClose className="icon btn-icon" />
								No
							</Button>
						</div>
					</Modal.Footer>
				</Modal>
			</div>

			{/* Toaster */}
			<Toast
				onClose={() => setShowToaster(false)}
				show={showToaster}
				delay={1500}
				autohide
				className={
					editingErrorToaster ? "custom-toaster err-toaster" : "custom-toaster"
				}
			>
				{/* <Toast.Header>
                    <img
                        src="holder.js/20x20?text=%20"
                        className="rounded mr-2"
                        alt=""
                    />
                    <strong className="mr-auto">Woohoo!!</strong>
                </Toast.Header> */}
				<Toast.Body>
					{editingSuccessToaster
						? "Successfully updated task."
						: editingErrorToaster
						? "Task not updated"
						: stopToaster
						? "Successfully stopped task."
						: restartToaster
						? "Successfully restarted task."
						: startToaster
						? "Successfully started task."
						: enableTaskTaskoaster
						? "Successfully enabled task"
						: deleteToaster
						? "Successfully disabled task."
						: errorTaskCreationToaster
						? "Not able to create task "
						: "Successfully added task."}
				</Toast.Body>
			</Toast>

			<Row>
				<Col md={12}>
					<div className="card pt-2">
						<div className="card-body">
							{editLoading ? <Loader /> : null}
							{loader ? <Loader /> : null}
							{show ? (
								<Fragment>
									{editHasErrors ? (
										<p>Error occurred. Unable to load edit task.</p>
									) : (
										<Tabs
											activeKey={tabActiveKey}
											defaultActiveKey="TaskConfiguration"
											transition={false}
											id="task-tabs"
											mountOnEnter={true}
											unmountOnExit={true}
											onSelect={(e, key) => {
												setCurrentTab(e);
												setValidated(false);
												setTabActiveKey(e);
											}}
										>
											<Tab
												eventKey="TaskConfiguration"
												title="Task Configuration"
											>
												<div className="tab-inner">
													{editLoading ? (
														<Loader />
													) : (
														<Form
															className="form"
															noValidate
															validated={validated}
															onSubmit={submitForm}
														>
															<Row>
																<Col md={12}>
																	<h5 className="h5 mt-3">
																		Task Configuration
																	</h5>
																</Col>
																<Col md={6} hidden={true}>
																	<Form.Group>
																		<Form.Label htmlFor="ClientName">
																			Client<span className="required">*</span>
																		</Form.Label>
																		<Form.Control
																			as="select"
																			required
																			disabled={
																				viewTask ? viewTask : editDisable
																			}
																			name="ClientId"
																			value={task.ClientId}
																			onBlur={trimValue}
																			onChange={handleInputChange}
																		>
																			<option disabled hidden>
																				Select Client
																			</option>
																			{taskDropdownLists.length > 0 ? (
																				<Fragment>
																					{taskDropdownLists[0].Client.map(
																						(item) => {
																							return (
																								<option
																									key={item.Id}
																									value={item.ClientName}
																								>
																									{item.ClientName}
																								</option>
																							);
																						}
																					)}
																				</Fragment>
																			) : null}
																		</Form.Control>
																		<Form.Control.Feedback type="invalid">
																			Please select client.
																		</Form.Control.Feedback>
																	</Form.Group>
																</Col>
																<Col md={6}>
																	<Form.Group>
																		<Form.Label htmlFor="FileSourceTypeId">
																			File Source
																			<span className="required">*</span>
																		</Form.Label>
																		<Form.Control
																			as="select"
																			disabled={
																				viewTask ? viewTask : editDisable
																			}
																			required
																			name="FileSourceTypeId"
																			value={task.FileSourceTypeId}
																			onBlur={trimValue}
																			onChange={(event) =>
																				handleFileSourceChange({
																					...task,
																					FileSourceTypeId: event.target.value,
																				})
																			}
																		>
																			<option disabled hidden>
																				Select File Source
																			</option>
																			{taskDropdownLists.length > 0 ? (
																				<Fragment>
																					{taskDropdownLists[0].FileSourceTypeList.map(
																						(item) => {
																							return (
																								<option
																									key={item.Id}
																									value={item.FileSourceName}
																								>
																									{item.FileSourceName}
																								</option>
																							);
																						}
																					)}
																				</Fragment>
																			) : null}
																			{/* <option>Inbound</option>
                                                                    <option>Outbound</option> */}
																		</Form.Control>
																		<Form.Control.Feedback type="invalid">
																			Please select file source.
																		</Form.Control.Feedback>
																	</Form.Group>
																</Col>
																<Col md={6}>
																	<Form.Group>
																		<Form.Label htmlFor="FileTypeId">
																			File<span className="required">*</span>
																		</Form.Label>
																		<Form.Control
																			as="select"
																			maxLength="100"
																			required
																			disabled={viewTask || true}
																			name="FileTypeId"
																			value={task.FileTypeId}
																			onBlur={trimValue}
																			onChange={handleInputChange}
																		>
																			<option disabled hidden>
																				Select File
																			</option>
																			{taskDropdownLists.length > 0 ? (
																				<Fragment>
																					{taskDropdownLists[0].FileTypesList.map(
																						(item, index) => {
																							return (
																								<option
																									key={index}
																									value={item.FileTypeName}
																								>
																									{item.FileTypeName}
																								</option>
																							);
																						}
																					)}
																				</Fragment>
																			) : null}
																		</Form.Control>
																		<Form.Control.Feedback type="invalid">
																			Please select file.
																		</Form.Control.Feedback>
																	</Form.Group>
																</Col>
																<Col md={6}>
																	<Form.Group>
																		<Form.Label htmlFor="FileFormatId">
																			File Format
																			<span className="required">*</span>
																		</Form.Label>
																		<Form.Control
																			as="select"
																			maxLength="30"
																			required
																			disabled={viewTask || true}
																			name="FileFormatId"
																			value={task.FileFormatId}
																			onBlur={trimValue}
																			onChange={handleInputChange}
																		>
																			<option disabled hidden>
																				Select File Format
																			</option>
																			{taskDropdownLists.length > 0 ? (
																				<Fragment>
																					{taskDropdownLists[0].FileFormatList.map(
																						(item, index) => {
																							return (
																								<option
																									key={index}
																									value={item.FileFormatName}
																								>
																									{item.FileFormatName}
																								</option>
																							);
																						}
																					)}
																				</Fragment>
																			) : null}
																		</Form.Control>
																		<Form.Control.Feedback type="invalid">
																			Please select file format.
																		</Form.Control.Feedback>
																	</Form.Group>
																</Col>
																<Col md={6}>
																	<Form.Group>
																		<Form.Label htmlFor="EDITaskTypeId">
																			Task Type
																			<span className="required">*</span>
																		</Form.Label>
																		<Form.Control
																			as="select"
																			required
																			disabled={viewTask || true}
																			name="EDITaskTypeId"
																			value={task.EDITaskTypeId}
																			onBlur={trimValue}
																			onChange={handleInputChange}
																		>
																			<option disabled hidden>
																				Select Task Type
																			</option>
																			{taskDropdownLists.length > 0 ? (
																				<Fragment>
																					{taskDropdownLists[0].EdiTaskTypesList.map(
																						(item, index) => {
																							return (
																								<option
																									key={index}
																									value={
																										item.TaskTypeDescription
																									}
																								>
																									{item.TaskTypeDescription}
																								</option>
																							);
																						}
																					)}
																				</Fragment>
																			) : null}
																		</Form.Control>
																		<Form.Control.Feedback type="invalid">
																			Please select task type.
																		</Form.Control.Feedback>
																	</Form.Group>
																</Col>
																<Col md={6}>
																	<Form.Group>
																		<Form.Label htmlFor="TaskName">
																			Task Name
																			<span className="required">*</span>
																		</Form.Label>
																		<Form.Control
																			type="text"
																			required
																			disabled={
																				viewTask ? viewTask : editDisable
																			}
																			name="TaskName"
																			value={task.TaskName}
																			min="2"
																			maxLength="250"
																			className={
																				taskNameError ? "is-invalid" : ""
																			}
																			isInvalid={taskNameError ? true : false}
																			onBlur={trimValue}
																			onChange={handleInputChange}
																		/>
																		{taskNameError ? (
																			<Form.Control.Feedback type="invalid">
																				Task name exists.
																			</Form.Control.Feedback>
																		) : (
																			<Form.Control.Feedback type="invalid">
																				Please enter task name.
																			</Form.Control.Feedback>
																		)}
																	</Form.Group>
																</Col>
																<Col md={6}>
																	<Form.Group>
																		<Form.Label htmlFor="FileNameFormat">
																			File Name Format
																			<span className="required">*</span>
																			<OverlayTrigger
																				key="file-name-format"
																				placement="bottom"
																				overlay={
																					<Tooltip id="file-name-format">
																						This field can be used to identify
																						the file at the time of processing
																						by using given text format here. The
																						text format should contain *.
																					</Tooltip>
																				}
																			>
																				<Button
																					variant="link"
																					className="input-info-btn ml-2 p-0"
																				>
																					<IoIosInformationCircle className="icon" />
																				</Button>
																			</OverlayTrigger>
																		</Form.Label>
																		<Form.Control
																			type="text"
																			maxLength="30"
																			required
																			disabled={viewTask}
																			name="FileNameFormat"
																			value={task.FileNameFormat}
																			min="2"
																			maxLength="250"
																			onBlur={trimValue}
																			onChange={handleInputChange}
																		/>
																		<Form.Control.Feedback type="invalid">
																			Please enter file name format.
																		</Form.Control.Feedback>
																	</Form.Group>
																</Col>

																{inbound ? (
																	<Fragment>
																		<Col md={6}>
																			<Form.Group>
																				<Form.Label htmlFor="ReadTries">
																					Number of Read Tries
																					<span className="required">*</span>
																				</Form.Label>
																				<Form.Control
																					type="text"
																					required
																					disabled={viewTask}
																					name="ReadTries"
																					value={task.ReadTries}
																					min="1"
																					maxLength="3"
																					onBlur={trimValue}
																					onChange={handleInputChange}
																				/>
																				<Form.Control.Feedback type="invalid">
																					Please enter number of read tries.
																				</Form.Control.Feedback>
																			</Form.Group>
																		</Col>
																		<Col md={6}>
																			<Form.Group>
																				<Form.Label htmlFor="File_Receive_Path">
																					File Receive Path
																					<span className="required">*</span>
																					<OverlayTrigger
																						key="file-watcher-path"
																						placement="bottom"
																						overlay={
																							<Tooltip id="file-watcher-path">
																								This field in combination with
																								the Root Path makes the complete
																								path, the file will be picked by
																								the watcher if it matches the
																								file format. *
																							</Tooltip>
																						}
																					>
																						<Button
																							variant="link"
																							className="input-info-btn ml-2 p-0"
																						>
																							<IoIosInformationCircle className="icon" />
																						</Button>
																					</OverlayTrigger>
																				</Form.Label>
																				<Form.Control
																					type="text"
																					required
																					disabled={viewTask}
																					name="File_Receive_Path"
																					value={task.File_Receive_Path}
																					min="1"
																					maxLength="512"
																					onBlur={trimValue}
																					onChange={handleInputChange}
																				/>
																				<Form.Control.Feedback type="invalid">
																					Please enter file receive path.
																				</Form.Control.Feedback>
																			</Form.Group>
																		</Col>
																	</Fragment>
																) : (
																	outbound && (
																		<Col md={6}>
																			<Form.Group>
																				<Form.Label htmlFor="OutboundResponsePath">
																					File Outbound Path
																					<span className="required">*</span>
																					<OverlayTrigger
																						key="file-outbound-path"
																						placement="bottom"
																						overlay={
																							<Tooltip id="file-outbound-path">
																								This field in combination with
																								the Root Path makes the complete
																								path, the file will be picked by
																								the watcher if it matches the
																								file format. *
																							</Tooltip>
																						}
																					>
																						<Button
																							variant="link"
																							className="input-info-btn ml-2 p-0"
																						>
																							<IoIosInformationCircle className="icon" />
																						</Button>
																					</OverlayTrigger>
																				</Form.Label>
																				<Form.Control
																					type="text"
																					required
																					disabled={viewTask}
																					name="OutboundResponsePath"
																					value={task.OutboundResponsePath}
																					min="2"
																					maxLength="250"
																					onBlur={trimValue}
																					onChange={handleInputChange}
																				/>
																				<Form.Control.Feedback type="invalid">
																					Please enter file outbound path.
																				</Form.Control.Feedback>
																			</Form.Group>
																		</Col>
																	)
																)}
																<Col md={6}>
																	<Form.Group>
																		<Form.Label htmlFor="SuccessArchivePath">
																			Success Archive Path
																			<span className="required">*</span>
																			<OverlayTrigger
																				key="success-archive-path"
																				placement="bottom"
																				overlay={
																					<Tooltip id="success-archive-path">
																						This field in combination with the
																						Root Path makes the complete path,
																						the file will be moved to this
																						folder after the file is processed
																						successfully. *
																					</Tooltip>
																				}
																			>
																				<Button
																					variant="link"
																					className="input-info-btn ml-2 p-0"
																				>
																					<IoIosInformationCircle className="icon" />
																				</Button>
																			</OverlayTrigger>
																		</Form.Label>
																		<Form.Control
																			type="text"
																			required
																			disabled={viewTask}
																			name="SuccessArchivePath"
																			value={task.SuccessArchivePath}
																			min="1"
																			maxLength="512"
																			onBlur={trimValue}
																			onChange={handleInputChange}
																		/>
																		<Form.Control.Feedback type="invalid">
																			Please enter success archive path.
																		</Form.Control.Feedback>
																	</Form.Group>
																</Col>
																<Col md={6}>
																	<Form.Group>
																		<Form.Label htmlFor="FailureArchivePath">
																			Failure Archive Path
																			<span className="required">*</span>
																			<OverlayTrigger
																				key="failure-archive-path"
																				placement="bottom"
																				overlay={
																					<Tooltip id="failure-archive-path">
																						This field in combination with the
																						Root Path makes the complete path,
																						the file will be moved to this
																						folder after the file is failed to
																						processes. *
																					</Tooltip>
																				}
																			>
																				<Button
																					variant="link"
																					className="input-info-btn ml-2 p-0"
																				>
																					<IoIosInformationCircle className="icon" />
																				</Button>
																			</OverlayTrigger>
																		</Form.Label>
																		<Form.Control
																			type="text"
																			required
																			disabled={viewTask}
																			name="FailureArchivePath"
																			value={task.FailureArchivePath}
																			min="1"
																			maxLength="512"
																			onBlur={trimValue}
																			onChange={handleInputChange}
																		/>
																		<Form.Control.Feedback type="invalid">
																			Please enter failure archive path.
																		</Form.Control.Feedback>
																	</Form.Group>
																</Col>
																<Col md={6}>
																	<Form.Group>
																		<Form.Label htmlFor="NotifyLabel">
																			Email Notification
																		</Form.Label>
																		<div>
																			<Form.Check
																				custom
																				inline
																				disabled={viewTask}
																				label="Yes"
																				type="radio"
																				name="Notify"
																				id="NotifyYes"
																				value="Y"
																				checked={task.Notify === "Y"}
																				onChange={(event) =>
																					handleNotifyChange({
																						...task,
																						Notify: event.target.value,
																					})
																				}
																			/>
																			<Form.Check
																				custom
																				inline
																				disabled={viewTask}
																				label="No"
																				type="radio"
																				name="Notify"
																				id="NotifyNo"
																				value="N"
																				checked={task.Notify === "N"}
																				onChange={(event) =>
																					handleNotifyChange({
																						...task,
																						Notify: event.target.value,
																					})
																				}
																			/>
																		</div>
																		<Form.Control.Feedback type="invalid">
																			Please enter file outbound path.
																		</Form.Control.Feedback>
																	</Form.Group>
																</Col>
																{Notify && (
																	<Col md={6}>
																		<Form.Group>
																			<Form.Label htmlFor="NotifyEmail">
																				Notify Email(s)
																				<span className="required">*</span>
																			</Form.Label>
																			<Form.Control
																				type="text"
																				required
																				disabled={viewTask}
																				className={
																					emailErr === 1
																						? "is-invalid"
																						: emailErr === 0
																						? "is-valid"
																						: ""
																				}
																				isInvalid={
																					emailErr === 1 ? true : false
																				}
																				name="NotifyEmail"
																				value={task.NotifyEmail}
																				onBlur={trimValue}
																				onChange={handleInputChange}
																			/>
																			<Form.Text className="text-muted">
																				You can enter multiple email ids using
																				comma(,) or semicolon(;) seperation.
																			</Form.Text>
																			{emailErr === 1 ? (
																				<Form.Control.Feedback type="invalid">
																					Please enter valid email address.
																				</Form.Control.Feedback>
																			) : null}
																			{task.NotifyEmail ? (
																				task.NotifyEmail.length === 0 ? (
																					<Form.Control.Feedback type="invalid">
																						Please enter atleast one email id.
																					</Form.Control.Feedback>
																				) : null
																			) : null}
																		</Form.Group>
																	</Col>
																)}

																<Col md={12}>
																	<hr />
																	<h5 className="h5 mt-3 mb-4">
																		Schedule Configuration
																	</h5>
																</Col>
																<Col md={6}>
																	<Form.Group>
																		<Form.Label htmlFor="ScheduleTypeId">
																			Schedule Type
																		</Form.Label>
																		<Form.Control
																			as="select"
																			disabled={viewTask}
																			name="ScheduleTypeId"
																			value={task.ScheduleTypeId}
																			onBlur={trimValue}
																			onChange={(event) =>
																				handleScheduleTypeChange({
																					...task,
																					ScheduleTypeId: event.target.value,
																				})
																			}
																		>
																			{taskDropdownLists.length > 0 ? (
																				<Fragment>
																					{taskDropdownLists[0].SchdulerType.map(
																						(item, index) => {
																							return (
																								<option
																									key={index}
																									value={item.ScheduleType}
																								>
																									{item.ScheduleType}
																								</option>
																							);
																						}
																					)}
																				</Fragment>
																			) : null}
																		</Form.Control>
																	</Form.Group>
																</Col>
																{scheduleTypeDaily ? (
																	<Fragment>
																		<Col md={6}>
																			<Form.Group>
																				<Form.Label htmlFor="EveryXDays">
																					Recurs Every{" "}
																					{scheduleTypeWeekly ? "Week" : "Day"}
																					(s)<span className="required">*</span>
																				</Form.Label>
																				<Form.Control
																					type="text"
																					required
																					disabled={viewTask}
																					name="EveryXDays"
																					value={task.EveryXDays}
																					min="1"
																					maxLength="3"
																					onBlur={trimValue}
																					onChange={handleInputChange}
																				/>
																				<Form.Control.Feedback type="invalid">
																					Please enter recurs every.
																				</Form.Control.Feedback>
																			</Form.Group>
																		</Col>
																	</Fragment>
																) : null}
																{scheduleTypeWeekly ? (
																	<Fragment>
																		<Col md={6}>
																			<Form.Group>
																				<Form.Label htmlFor="EveryXWeeks">
																					Recurs Every{" "}
																					{scheduleTypeWeekly ? "Week" : "Day"}
																					(s)<span className="required">*</span>
																				</Form.Label>
																				<Form.Control
																					type="text"
																					required
																					disabled={viewTask}
																					name="EveryXWeeks"
																					value={task.EveryXWeeks}
																					min="1"
																					maxLength="3"
																					onBlur={trimValue}
																					onChange={handleInputChange}
																				/>
																				<Form.Control.Feedback type="invalid">
																					Please enter recurs every.
																				</Form.Control.Feedback>
																			</Form.Group>
																		</Col>
																		<Col md={6}>
																			<Row>
																				<Col md={9}>
																					<Form.Group>
																						<Form.Label htmlFor="ScheduleWeekday">
																							Week Days
																							<span className="required">
																								*
																							</span>
																						</Form.Label>
																						<Select
																							options={options}
																							values={
																								editingTask
																									? [...ScheduleWeekdays]
																									: []
																							}
																							required
																							multi
																							name="ScheduleWeekday"
																							onChange={(value) =>
																								onChangeScheduleWeekday(value)
																							}
																							itemRenderer={({
																								item,
																								methods,
																							}) => (
																								<li
																									className="multi-select-item"
																									onClick={() =>
																										methods.addItem(item)
																									}
																								>
																									<Form.Check
																										type="checkbox"
																										label={item.label}
																										onChange={() =>
																											methods.addItem(item)
																										}
																										checked={methods.isSelected(
																											item
																										)}
																									/>
																								</li>
																							)}
																							disabled={viewTask}
																						/>
																						<Form.Control.Feedback type="invalid">
																							Please select week days.
																						</Form.Control.Feedback>
																					</Form.Group>
																				</Col>
																			</Row>
																		</Col>
																	</Fragment>
																) : null}

																{scheduleTypeDaily ? (
																	<Col md={9}>
																		<Row>
																			<Col md={6}>
																				<Form.Group>
																					<Form.Label htmlFor="ScheduleWeekday">
																						Days
																					</Form.Label>
																					<Select
																						options={options}
																						values={
																							editingTask
																								? [...ScheduleWeekdays]
																								: []
																						}
																						multi
																						name="ScheduleWeekday"
																						onChange={(value) =>
																							onChangeScheduleWeekday(value)
																						}
																						itemRenderer={({
																							item,
																							methods,
																						}) => (
																							<li
																								className="multi-select-item"
																								onClick={() =>
																									methods.addItem(item)
																								}
																							>
																								<Form.Check
																									type="checkbox"
																									label={item.label}
																									onChange={() =>
																										methods.addItem(item)
																									}
																									checked={methods.isSelected(
																										item
																									)}
																								/>
																							</li>
																						)}
																						disabled={viewTask}
																					/>
																					<Form.Control.Feedback type="invalid">
																						Please select days.
																					</Form.Control.Feedback>
																				</Form.Group>
																			</Col>
																		</Row>
																	</Col>
																) : null}
																<Col md={3}>
																	<Form.Group>
																		<Form.Label htmlFor="IsExcludeHolidays">
																			Exclude Holidays
																		</Form.Label>
																		<div>
																			<Form.Check
																				inline
																				type="checkbox"
																				id="IsExcludeHolidays"
																				name="IsExcludeHolidays"
																				value={task.IsExcludeHolidays}
																				checked={task.IsExcludeHolidays}
																				onChange={(event) =>
																					handleHolidayChange(event)
																				}
																				disabled={viewTask}
																			/>
																		</div>
																		<Form.Control.Feedback type="invalid">
																			Please select Exclude Holidays.
																		</Form.Control.Feedback>
																	</Form.Group>
																</Col>

																{scheduleTypeMonthly ? (
																	<Col md={12}>
																		<Row>
																			<Col md={5}>
																				<Form.Group className="label-inline">
																					<Form.Label htmlFor="DayOfMonth">
																						<Form.Check
																							custom
																							inline
																							type="radio"
																							disabled={viewTask}
																							label="Day"
																							name="DaysOfMonth"
																							id="DayOfMonthYes"
																							value="Y"
																							checked={task.DaysOfMonth === "Y"}
																							onChange={(event) =>
																								handleDaysOfMonthChange({
																									...task,
																									DaysOfMonth:
																										event.target.value,
																								})
																							}
																						/>
																						<span className="required">*</span>
																					</Form.Label>
																					<Form.Control
																						type="text"
																						disabled={
																							viewTask
																								? viewTask
																								: dayXMonthsDisable
																						}
																						required
																						name="DayOfMonth"
																						min="1"
																						maxLength="2"
																						onBlur={trimValue}
																						onChange={handleInputChange}
																						value={task.DayOfMonth}
																					/>
																					<Form.Control.Feedback type="invalid">
																						Please enter day of month.
																					</Form.Control.Feedback>
																				</Form.Group>
																			</Col>
																			<Col md={1}>
																				<div className="text-center in-txt">
																					of Every
																				</div>
																			</Col>
																			<Col md={5}>
																				<Form.Group className="input-inline">
																					<Form.Label htmlFor="EveryXMonths"></Form.Label>
																					<Form.Control
																						type="text"
																						disabled={
																							viewTask
																								? viewTask
																								: dayXMonthsDisable
																						}
																						required
																						name="EveryXMonths"
																						min="1"
																						maxLength="3"
																						onBlur={trimValue}
																						onChange={handleInputChange}
																						value={task.EveryXMonths}
																					/>
																					<Form.Control.Feedback type="invalid">
																						Please enter day of month.
																					</Form.Control.Feedback>
																				</Form.Group>
																			</Col>
																			<Col md={1}>
																				<div className="text-left in-txt">
																					Month(s)
																				</div>
																			</Col>
																		</Row>
																		<Row>
																			<Col md={5}>
																				<Form.Group className="label-inline">
																					<Form.Label htmlFor="DayOfMonth">
																						<Form.Check
																							custom
																							inline
																							type="radio"
																							disabled={viewTask}
																							label="The"
																							name="DaysOfMonth"
																							id="DayOfMonthNo"
																							value="N"
																							checked={task.DaysOfMonth === "N"}
																							onChange={(event) =>
																								handleDaysOfMonthChange({
																									...task,
																									DaysOfMonth:
																										event.target.value,
																								})
																							}
																						/>
																						<span className="required">*</span>
																					</Form.Label>
																					<Row>
																						<Col md={6}>
																							<Form.Group>
																								<Form.Control
																									as="select"
																									required
																									disabled={
																										viewTask
																											? viewTask
																											: theXMonthsDisable
																									}
																									name="MonthlySpecificDatePartOne"
																									value={
																										task.MonthlySpecificDatePartOne
																									}
																									onBlur={trimValue}
																									onChange={handleInputChange}
																								>
																									{taskDropdownLists.length >
																									0 ? (
																										<Fragment>
																											{taskDropdownLists[0].MonthlySpecificDatePartOneList.map(
																												(item, index) => {
																													return (
																														<option
																															key={index}
																															value={item.value}
																														>
																															{item.value}
																														</option>
																													);
																												}
																											)}
																										</Fragment>
																									) : null}
																								</Form.Control>
																							</Form.Group>
																						</Col>
																						<Col md={6}>
																							<Form.Group>
																								<Form.Control
																									as="select"
																									required
																									disabled={
																										viewTask
																											? viewTask
																											: theXMonthsDisable
																									}
																									name="MonthlySpecificDatePartTwo"
																									value={
																										task.MonthlySpecificDatePartTwo
																									}
																									onBlur={trimValue}
																									onChange={handleInputChange}
																								>
																									{taskDropdownLists.length >
																									0 ? (
																										<Fragment>
																											{taskDropdownLists[0].MonthlySpecificDatePartTwoList.map(
																												(item, index) => {
																													return (
																														<option
																															key={index}
																															value={item.value}
																														>
																															{item.value}
																														</option>
																													);
																												}
																											)}
																										</Fragment>
																									) : null}
																								</Form.Control>
																							</Form.Group>
																						</Col>
																					</Row>
																					<Form.Control.Feedback type="invalid">
																						Please select day of month.
																					</Form.Control.Feedback>
																				</Form.Group>
																			</Col>
																			<Col md={1}>
																				<div className="text-center in-txt">
																					of Every
																				</div>
																			</Col>
																			<Col md={5}>
																				<Form.Group className="input-inline">
																					<Form.Label htmlFor="EveryXMonths"></Form.Label>
																					<Form.Control
																						type="text"
																						disabled={
																							viewTask
																								? viewTask
																								: theXMonthsDisable
																						}
																						required
																						min="1"
																						maxLength="3"
																						name="EveryXMonths2"
																						value={task.EveryXMonths2}
																						onBlur={trimValue}
																						onChange={handleInputChange}
																					/>
																					<Form.Control.Feedback type="invalid">
																						Please select day of month.
																					</Form.Control.Feedback>
																				</Form.Group>
																			</Col>
																			<Col md={1}>
																				<div className="text-left in-txt">
																					Month(s)
																				</div>
																			</Col>
																		</Row>
																	</Col>
																) : null}

																{/* Quarterly fileds */}
																{scheduleTypeQuarterly ? (
																	<Col md={12}>
																		<Row>
																			<Col md={3}>
																				<Form.Group className="label-inline">
																					<Form.Label htmlFor="MonthsOfQuarterly">
																						<Form.Check
																							custom
																							inline
																							type="radio"
																							disabled={viewTask}
																							label="Month"
																							name="MonthsOfQuarterly"
																							id="MonthsOfQuarterlyYes"
																							value="Y"
																							checked={
																								task.MonthsOfQuarterly === "Y"
																							}
																							onChange={(event) =>
																								handleMonthsOfQuarterlyChange({
																									...task,
																									MonthsOfQuarterly:
																										event.target.value,
																								})
																							}
																						/>
																						<span className="required">*</span>
																					</Form.Label>
																					<Form.Control
																						as="select"
																						disabled={
																							viewTask
																								? viewTask
																								: monthXQuarterlyDisable
																						}
																						required
																						name="MonthOfQuarterly"
																						min="1"
																						maxLength="2"
																						onBlur={trimValue}
																						onChange={handleInputChange}
																						value={task.MonthOfQuarterly}
																					>
																						{taskDropdownLists.length > 0 ? (
																							<Fragment>
																								{taskDropdownLists[0].QuarterlyMonths.map(
																									(item, index) => {
																										return (
																											<option
																												key={index}
																												value={item.value}
																											>
																												{item.value}
																											</option>
																										);
																									}
																								)}
																							</Fragment>
																						) : null}
																					</Form.Control>
																					<Form.Control.Feedback type="invalid">
																						Please selct month of quarter.
																					</Form.Control.Feedback>
																				</Form.Group>
																			</Col>
																			<Col md={3}>
																				<Form.Group className="label-inline">
																					<Form.Label
																						htmlFor="MonthsOfQuarterlyDay"
																						className="mb-7"
																					>
																						Day
																						<span className="required">*</span>
																					</Form.Label>
																					<Form.Control
																						type="text"
																						disabled={
																							viewTask
																								? viewTask
																								: monthXQuarterlyDisable
																						}
																						required
																						name="DayOfQuarterlyMonth"
																						min="1"
																						maxLength="2"
																						onBlur={trimValue}
																						onChange={handleInputChange}
																						value={task.DayOfQuarterlyMonth}
																					/>
																					<Form.Control.Feedback type="invalid">
																						Please enter day of quarter.
																					</Form.Control.Feedback>
																				</Form.Group>
																			</Col>
																			<Col md={1}>
																				<div className="text-center in-txt">
																					of Every
																				</div>
																			</Col>
																			<Col md={4}>
																				<Form.Group className="input-inline">
																					<Form.Label htmlFor="EveryXMonths"></Form.Label>
																					<Form.Control
																						type="text"
																						disabled={
																							viewTask
																								? viewTask
																								: monthXQuarterlyDisable
																						}
																						required
																						name="EveryXQuarterlyMonths"
																						min="1"
																						maxLength="1"
																						onBlur={trimValue}
																						onChange={handleInputChange}
																						value={task.EveryXQuarterlyMonths}
																					/>
																					<Form.Control.Feedback type="invalid">
																						Please enter day of month.
																					</Form.Control.Feedback>
																				</Form.Group>
																			</Col>
																			<Col md={1}>
																				<div className="text-left in-txt">
																					Quarterly
																				</div>
																			</Col>
																		</Row>
																		<Row>
																			<Col md={6}>
																				<Form.Group className="label-inline">
																					<Form.Label htmlFor="MonthsOfQuarterly">
																						<Form.Check
																							custom
																							inline
																							type="radio"
																							disabled={viewTask}
																							label="The"
																							name="MonthsOfQuarterly"
																							id="MonthsOfQuarterlyNo"
																							value="N"
																							checked={
																								task.MonthsOfQuarterly === "N"
																							}
																							onChange={(event) =>
																								handleMonthsOfQuarterlyChange({
																									...task,
																									MonthsOfQuarterly:
																										event.target.value,
																								})
																							}
																						/>
																						<span className="required">*</span>
																					</Form.Label>
																					<Row>
																						<Col md={4}>
																							<Form.Group className="label-inline">
																								<Form.Control
																									as="select"
																									disabled={
																										viewTask
																											? viewTask
																											: theXQuarterlyDisable
																									}
																									required
																									name="MonthOfQuarterly2"
																									min="1"
																									maxLength="2"
																									onBlur={trimValue}
																									onChange={handleInputChange}
																									value={task.MonthOfQuarterly2}
																								>
																									{taskDropdownLists.length >
																									0 ? (
																										<Fragment>
																											{taskDropdownLists[0].QuarterlyMonths.map(
																												(item, index) => {
																													return (
																														<option
																															key={index}
																															value={item.value}
																														>
																															{item.value}
																														</option>
																													);
																												}
																											)}
																										</Fragment>
																									) : null}
																								</Form.Control>
																								<Form.Control.Feedback type="invalid">
																									Please selct month of quarter.
																								</Form.Control.Feedback>
																							</Form.Group>
																						</Col>
																						<Col md={4}>
																							<Form.Group>
																								<Form.Control
																									as="select"
																									required
																									disabled={
																										viewTask
																											? viewTask
																											: theXQuarterlyDisable
																									}
																									name="QuarterlySpecificDatePartOne"
																									value={
																										task.QuarterlySpecificDatePartOne
																									}
																									onBlur={trimValue}
																									onChange={handleInputChange}
																								>
																									{taskDropdownLists.length >
																									0 ? (
																										<Fragment>
																											{taskDropdownLists[0].MonthlySpecificDatePartOneList.map(
																												(item, index) => {
																													return (
																														<option
																															key={index}
																															value={item.value}
																														>
																															{item.value}
																														</option>
																													);
																												}
																											)}
																										</Fragment>
																									) : null}
																								</Form.Control>
																							</Form.Group>
																						</Col>
																						<Col md={4}>
																							<Form.Group>
																								<Form.Control
																									as="select"
																									required
																									disabled={
																										viewTask
																											? viewTask
																											: theXQuarterlyDisable
																									}
																									name="QuarterlySpecificDatePartTwo"
																									value={
																										task.QuarterlySpecificDatePartTwo
																									}
																									onBlur={trimValue}
																									onChange={handleInputChange}
																								>
																									{taskDropdownLists.length >
																									0 ? (
																										<Fragment>
																											{taskDropdownLists[0].MonthlySpecificDatePartTwoList.map(
																												(item, index) => {
																													return (
																														<option
																															key={index}
																															value={item.value}
																														>
																															{item.value}
																														</option>
																													);
																												}
																											)}
																										</Fragment>
																									) : null}
																								</Form.Control>
																							</Form.Group>
																						</Col>
																					</Row>
																					<Form.Control.Feedback type="invalid">
																						Please select day of month.
																					</Form.Control.Feedback>
																				</Form.Group>
																			</Col>
																			<Col md={1}>
																				<div className="text-center in-txt">
																					of Every
																				</div>
																			</Col>
																			<Col md={4}>
																				<Form.Group className="input-inline">
																					<Form.Label htmlFor="EveryXMonths"></Form.Label>
																					<Form.Control
																						type="text"
																						disabled={
																							viewTask
																								? viewTask
																								: theXQuarterlyDisable
																						}
																						required
																						min="1"
																						maxLength="3"
																						name="EveryXQuarterlyMonths2"
																						value={task.EveryXQuarterlyMonths2}
																						onBlur={trimValue}
																						onChange={handleInputChange}
																					/>
																					<Form.Control.Feedback type="invalid">
																						Please select day of month.
																					</Form.Control.Feedback>
																				</Form.Group>
																			</Col>
																			<Col md={1}>
																				<div className="text-left in-txt">
																					Quarterly
																				</div>
																			</Col>
																		</Row>
																	</Col>
																) : null}

																<Col md={6}>
																	<Form.Group className="radio-inline-group">
																		<Form.Label htmlFor="OccursOnceAt">
																			<Form.Check
																				custom
																				inline
																				disabled={viewTask}
																				type="radio"
																				label="Occurs Once At"
																				name="IsOccursOnceAt"
																				id="IsOccursOnceAtYes"
																				value="Y"
																				checked={task.IsOccursOnceAt === "Y"}
																				onChange={(event) =>
																					handleOccursOnceAtChange({
																						...task,
																						IsOccursOnceAt: event.target.value,
																					})
																				}
																			/>
																			<span className="required">*</span>
																		</Form.Label>
																		<div className="date-picker ungroup-date-picker pos-rl">
																			<IoMdClock className="icon date-icon ungroup-date-icon" />
																			<Form.Control
																				as={DatePicker}
																				selected={occursOnceAt}
																				onChange={(date) => {
																					setOccursOnceAt(date);
																				}}
																				showTimeSelect
																				showTimeSelectOnly
																				timeIntervals={15}
																				timeCaption="Time"
																				dateFormat="hh:mm aa"
																				disabled={
																					viewTask
																						? viewTask
																						: occursOnceAtInputDisable
																				}
																				name="SpecificTime"
																				required
																				onKeyDown={(e) => {
																					e.preventDefault();
																					return false;
																				}}
																			/>
																			<Form.Control.Feedback
																				type="invalid"
																				className="date-err-msg"
																			>
																				Please select occurs once at.
																			</Form.Control.Feedback>
																		</div>
																	</Form.Group>
																</Col>
																<Col md={6}>
																	<Form.Group className="radio-inline-group">
																		<Form.Label htmlFor="OccursEvery">
																			<Form.Check
																				custom
																				inline
																				disabled={viewTask}
																				type="radio"
																				label="Occurs Every"
																				name="IsOccursOnceAt"
																				id="IsOccursOnceAtNo"
																				value="N"
																				checked={task.IsOccursOnceAt === "N"}
																				onChange={(event) =>
																					handleOccursOnceAtChange({
																						...task,
																						IsOccursOnceAt: event.target.value,
																					})
																				}
																			/>
																			<span className="required">*</span>
																		</Form.Label>
																		<div className="date-picker ungroup-date-picker pos-rl">
																			<Row>
																				<Col md={6}>
																					<Form.Control
																						type="text"
																						disabled={
																							viewTask
																								? viewTask
																								: occursEveryInputDisable
																						}
																						required
																						name="EveryXminutes"
																						min="2"
																						maxLength="4"
																						onBlur={trimValue}
																						onChange={handleInputChange}
																						value={task.EveryXminutes}
																					/>
																					<Form.Control.Feedback type="invalid">
																						Please enter occurs every.
																					</Form.Control.Feedback>
																				</Col>
																				<Col md={6}>
																					<Form.Control
																						as="select"
																						disabled={
																							viewTask
																								? viewTask
																								: occursEveryInputDisable
																						}
																						required
																						name="TimeRecurrenceTypeId"
																						onBlur={trimValue}
																						onChange={handleInputChange}
																						value={task.TimeRecurrenceTypeId}
																					>
																						{taskDropdownLists.length > 0 ? (
																							<Fragment>
																								{taskDropdownLists[0].TimeRecurrenceType.map(
																									(item) => {
																										return (
																											<option
																												key={item.value}
																												value={item.value}
																											>
																												{item.value}
																											</option>
																										);
																									}
																								)}
																							</Fragment>
																						) : null}
																					</Form.Control>
																				</Col>
																				<Col md={6}>
																					<div className="date-picker ungroup-date-picker pos-rl mt-3">
																						<Form.Label htmlFor="OccursEveryStartTime">
																							Starting At
																							<span className="required">
																								*
																							</span>
																						</Form.Label>
																						<IoMdClock className="icon date-icon" />
																						<DatePicker
																							selected={occursEveryStartTime}
																							onChange={(date) =>
																								setOccursEveryStartTime(date)
																							}
																							showTimeSelect
																							showTimeSelectOnly
																							timeIntervals={15}
																							timeCaption="Time"
																							dateFormat="hh:mm aa"
																							disabled={
																								viewTask
																									? viewTask
																									: occursEveryInputDisable
																							}
																							name="StartTime"
																							required
																							onKeyDown={(e) => {
																								e.preventDefault();
																								return false;
																							}}
																							className={
																								startTimeGreaterErr
																									? "form-control is-invalid"
																									: " form-control"
																							}
																							isInvalid={
																								startTimeGreaterErr
																									? true
																									: false
																							}
																						/>
																					</div>
																					{startTimeGreaterErr ? (
																						<div class="invalid-feedback d-block">
																							Start time should not be greater
																							than end time.
																						</div>
																					) : null}
																				</Col>
																				<Col md={6}>
																					<div className="date-picker ungroup-date-picker pos-rl mt-3">
																						<Form.Label htmlFor="OccursEveryEndTime">
																							Ending At
																							<span className="required">
																								*
																							</span>
																						</Form.Label>
																						<IoMdClock className="icon date-icon" />
																						<DatePicker
																							selected={occursEveryEndTime}
																							onChange={(date) =>
																								setOccursEveryEndTime(date)
																							}
																							showTimeSelect
																							showTimeSelectOnly
																							timeIntervals={15}
																							timeCaption="Time"
																							dateFormat="hh:mm aa"
																							disabled={
																								viewTask
																									? viewTask
																									: occursEveryInputDisable
																							}
																							name="EndTime"
																							required
																							onKeyDown={(e) => {
																								e.preventDefault();
																								return false;
																							}}
																							className="form-control"
																						/>
																					</div>
																				</Col>
																			</Row>
																		</div>
																		<Form.Control.Feedback type="invalid">
																			Please select occurs once at.
																		</Form.Control.Feedback>
																	</Form.Group>
																</Col>
																<Col md={6}>
																	<Form.Group>
																		<div className="date-picker ungroup-date-picker pos-rl task-startdate">
																			<IoMdCalendar className="icon date-icon" />
																			<Form.Label htmlFor="StartDate">
																				Start Date
																				<span className="required">*</span>
																			</Form.Label>
																			<DatePicker
																				selected={startDate}
																				onChange={(date) => setStartDate(date)}
																				minDate={new Date()}
																				// maxDate={addMonths(new Date(), 5)}
																				showDisabledMonthNavigation
																				name="StartDate"
																				required
																				className={
																					startDateGreaterErr
																						? "form-control is-invalid"
																						: " form-control"
																				}
																				isInvalid={
																					startDateGreaterErr ? true : false
																				}
																				disabled={viewTask}
																			/>
																		</div>
																		{startDateGreaterErr ? (
																			<div className="err-feedback d-block">
																				Start date should not be greater than
																				end date.
																			</div>
																		) : null}
																		{startDateErr ? (
																			<div className="err-feedback d-block">
																				Please select start date.
																			</div>
																		) : null}
																	</Form.Group>
																</Col>
																<Col md={6}>
																	<Row>
																		<Col md={6}>
																			<Form.Group>
																				<div className="date-picker ungroup-date-picker pos-rl task-enddate">
																					<Form.Label htmlFor="EndDate">
																						<Form.Check
																							custom
																							inline
																							type="radio"
																							disabled={viewTask}
																							label="End Date"
																							name="IsEndDate"
																							id="EndDate"
																							value="Y"
																							checked={task.IsEndDate === "Y"}
																							onChange={handleInputChange}
																						/>
																					</Form.Label>
																					<IoMdCalendar className="icon date-icon" />
																					<DatePicker
																						selected={endDate}
																						onChange={(date) =>
																							setEndDate(date)
																						}
																						minDate={new Date()}
																						// maxDate={addMonths(new Date(), 5)}
																						showDisabledMonthNavigation
																						name="EndDate"
																						className="form-control"
																						disabled={
																							isEndDateDisable
																								? isEndDateDisable
																								: viewTask
																						}
																						required
																					/>
																				</div>
																			</Form.Group>
																		</Col>
																		<Col md={6}>
																			<Form.Group>
																				<div className="date-picker ungroup-date-picker pos-rl">
																					<Form.Label htmlFor="NoEndDate">
																						<Form.Check
																							custom
																							inline
																							type="radio"
																							disabled={viewTask}
																							label="No End Date"
																							name="IsEndDate"
																							id="NoEndDate"
																							value="N"
																							checked={task.IsEndDate === "N"}
																							onChange={handleInputChange}
																						/>
																					</Form.Label>
																				</div>
																			</Form.Group>
																		</Col>
																	</Row>
																</Col>
																<Col md={12}>
																	<Form.Group>
																		<div className="text-right">
																			{outbound ? (
																				<Fragment>
																					{/* viewTask ? viewTask : continueBtnDisable */}
																					<Button
																						disabled={
																							viewTask
																								? viewTask
																								: continueBtnDisable
																						}
																						className="ml-3"
																						type="submit"
																						name="btn"
																						value="saveOrUpdateContinue"
																						onClick={() =>
																							setSubmitSaveOrUpdate(true)
																						}
																					>
																						<IoMdDoneAll className="icon btn-icon" />
																						{editingTask
																							? "Update and Continue"
																							: "Save and Continue"}
																					</Button>
																					<Button
																						disabled={
																							viewTask
																								? viewTask
																								: continueBtnDisable
																						}
																						className="ml-3"
																						type="submit"
																						name="btn1"
																						value="saveOrUpdate"
																						onClick={() =>
																							setSubmitSaveOrUpdate(false)
																						}
																					>
																						<IoMdDoneAll className="icon btn-icon" />
																						{editingTask ? "Update" : "Save"}
																					</Button>
																					<Button
																						variant="danger"
																						className="cancel-btn ml-3"
																						onClick={() => cancelHandler()}
																					>
																						<IoIosClose className="icon btn-icon" />
																						Cancel
																					</Button>
																				</Fragment>
																			) : (
																				<Fragment>
																					{/* viewTask ? viewTask : submitBtnDisable */}
																					<Button
																						hidden={true}
																						disabled={
																							viewTask
																								? viewTask
																								: submitBtnDisable
																						}
																						className="ml-3"
																						type="submit"
																						name="btn"
																						value="saveOrUpdateContinue"
																						onClick={() =>
																							setSubmitSaveOrUpdate(true)
																						}
																					>
																						<IoMdDoneAll className="icon btn-icon" />
																						{editingTask
																							? "Update and Continue"
																							: "Save and Continue"}
																					</Button>
																					<Button
																						type="submit"
																						name="btn1"
																						value="saveOrUpdate"
																						className="ml-3"
																						onClick={() =>
																							setSubmitSaveOrUpdate(false)
																						}
																						disabled={
																							viewTask
																								? viewTask
																								: submitBtnDisable
																						}
																					>
																						<IoMdDoneAll className="icon btn-icon" />
																						{editingTask ? "Update" : "Submit"}
																					</Button>
																					<Button
																						variant="danger"
																						className="cancel-btn ml-3"
																						onClick={() => cancelHandler()}
																					>
																						<IoIosClose className="icon btn-icon" />
																						Cancel
																					</Button>
																				</Fragment>
																			)}
																		</div>
																	</Form.Group>
																</Col>
															</Row>
														</Form>
													)}
												</div>
											</Tab>
											{outbound && (
												<Tab
													eventKey="CommunicationConfiguration"
													title="Endpoints Configuration"
												>
													<CommunicationConfiguration
														task={task}
														tasks={taskData}
														communicationConfig={editTask.communicationConfig}
														editing={editing}
														editDisable={editDisable}
														setShow={setShow}
														setAdding={setAdding}
														setTask={setTask}
														taskIntialState={initialState}
														cancelHandler={cancelHandler}
														viewTask={viewTask}
														setTabActiveKey={setTabActiveKey}
													/>
												</Tab>
											)}
											{/* <Tab eventKey="DataSecurity" title="Data Security">
                                                <DataSecurity
                                                    task={task}
                                                    setTask={setTask}
                                                    tasks={taskData}
                                                    editing={editing}
                                                    editDisable={editDisable}
                                                    viewTask={viewTask}
                                                    setShow={setShow}
                                                    setAdding={setAdding}
                                                    intialState={initialState}
                                                    cancelHandler={cancelHandler}
                                                    setTabActiveKey={setTabActiveKey}
                                                />
                                            </Tab> */}
										</Tabs>
									)}
								</Fragment>
							) : (
								<Fragment>
									{loading ? (
										<Loader />
									) : editingLoading ? (
										<Loader />
									) : hasErrors ? (
										<p>Error occurred. Unable to load tasks.</p>
									) : editHasErrors ? (
										<p>Error occurred. Unable to load edit task.</p>
									) : (
										<div className="task-grid">
											{tasks.length > 0 ? (
												<ReactTable
													columns={columns}
													data={tasks}
													defaultPageSize={10}
												/>
											) : (
												<div className="no-data">No data found.</div>
											)}
										</div>
									)}
								</Fragment>
							)}
						</div>
					</div>
					<Footer />
				</Col>
			</Row>
		</section>
	);
};

// Map Redux state to React component props
const mapStateToProps = (state) => ({
	loading: state.tasks.loading,
	tasks: state.tasks.tasks,
	hasErrors: state.tasks.hasErrors,
	listLoading: state.taskDropdownLists.loading,
	listHasErrors: state.taskDropdownLists.hasErrors,
	taskDropdownLists: state.taskDropdownLists.taskDropdownLists,
	editLoading: state.editTask.loading,
	editTask: state.editTask.editTask,
	editHasErrors: state.editTask.hasErrors,
	editingTask: state.editTask.editingTask,
	editingLoading: state.editTask.editingLoading,
	editingSuccessToaster: state.editTask.editingSuccessToaster,
	editingErrorToaster: state.editTask.editingErrorToaster,
	errorTaskCreationToaster: state.tasks.errorTaskCreationToaster,
});

// Connect Redux to React
export default connect(mapStateToProps)(TaskPage);
